"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dict = {
    "VERSION": "3.3.4",
    11: 'id',
    21: 'idtype',
    22: 'machineid',
    24: 'filelist',
    25: 'dir',
    26: 'file',
    27: 'name',
    28: 'noOfFrames',
    29: 'fonts',
    30: 'font',
    31: 'height',
    32: 'x',
    33: 'y',
    34: 'fontName',
    35: 'charSet',
    36: 'xFile',
    37: 'textureFile',
    38: 'textureFile1',
    39: 'textureFile2',
    40: 'textureFile3',
    41: 'textureFile4',
    42: 'textureFile5',
    43: 'textureFile6',
    44: 'textureFile7',
    45: 'textureFile8',
    46: 'textureFile9',
    47: 'size',
    48: 'fullScreen',
    49: 'cube',
    50: 'center',
    51: 'side',
    52: 'animatedMesh',
    53: 'spriteTypes',
    54: 'spriteType',
    55: 'objectTypes',
    56: 'cubeType',
    57: 'meshType',
    58: 'mapMeshType',
    59: 'animatedMeshType',
    60: 'sprites',
    61: 'sprite',
    62: 'objects',
    63: 'group',
    64: 'animation',
    65: 'object',
    66: 'defaultAnimationTime',
    67: 'particleType',
    68: 'flareType',
    69: 'nr',
    70: 'resizeableSpriteType',
    71: 'textSpriteType',
    72: 'lightType',
    73: 'diffuse',
    74: 'specular',
    75: 'ambient',
    76: 'position',
    77: 'direction',
    78: 'range',
    79: 'falloff',
    80: 'attenuation',
    81: 'theta',
    82: 'phi',
    83: 'lightTypes',
    84: 'light',
    85: 'corneredTileSpriteType',
    86: 'color',
    87: 'arrowType',
    88: 'endAt',
    89: 'effect',
    90: 'effectFile',
    91: 'primitiveType',
    92: 'xAnimationFile',
    93: 'scale',
    94: 'mapTextType',
    95: 'graphicsSettings',
    96: 'refreshRate',
    97: 'firstRun',
    98: 'userAnisotropy',
    99: 'shadows',
    100: 'panelType',
    101: 'seasonInfo',
    102: 'origo',
    103: 'cameraMove',
    104: 'camera',
    105: 'start',
    106: 'stop',
    107: 'target',
    108: 'up',
    109: 'duration',
    110: 'speed',
    111: 'anti_alias_geometry',
    112: 'shadow_effect',
    113: 'dynamic_lights',
    114: 'format',
    115: 'left',
    116: 'right',
    117: 'centre',
    118: 'gamma',
    485: 'borderless',
    499: 'uv_animation_speed',
    511: 'override_resolution_safety',
    119: 'gregoriandat',
    120: 'year',
    121: 'month',
    122: 'day',
    123: 'newday',
    124: 'guitypes',
    125: 'guiButtonType',
    126: 'upSprite',
    127: 'downSprite',
    128: 'dissableSprite',
    129: 'overSprite',
    130: 'quadTextureSprite',
    131: 'textBoxType',
    132: 'borderSize',
    133: 'parent',
    134: 'leftButton',
    135: 'rightButton',
    136: 'slider',
    137: 'track',
    138: 'scrollbarType',
    139: 'priority',
    140: 'buttonDrag',
    141: 'text',
    142: 'maxHeight',
    143: 'maxWidth',
    144: 'tooltip',
    145: 'tooltipText',
    146: 'delayedTooltipText',
    147: 'minValue',
    148: 'maxValue',
    149: 'stepSize',
    150: 'startValue',
    151: 'horizontal',
    152: 'staydownbutton',
    153: 'windowType',
    154: 'background',
    155: 'moveable',
    156: 'resizeableWindow',
    157: 'radioButton',
    158: 'radioButtonGroupType',
    159: 'verticalScrollbar',
    160: 'horizontalScrollbar',
    161: 'scrollbargroupType',
    162: 'radioScrollbar',
    163: 'dontRender',
    164: 'horizontalBorder',
    165: 'verticalBorder',
    166: 'listBoxItemType',
    167: 'listBoxType',
    168: 'editBoxType',
    169: '3dButtonType',
    170: 'buttonMesh',
    171: 'buttonText',
    172: 'buttonFont',
    173: '3dposition',
    174: 'fixedsize',
    175: '3dIconType',
    176: 'positionType',
    177: 'layout',
    178: 'multiSpriteButtonType',
    179: 'icon',
    180: 'iconType',
    181: 'dropDown',
    182: 'heading',
    183: 'dropDownMenuType',
    184: 'step',
    185: 'language',
    186: 'l_english',
    187: 'l_french',
    188: 'l_german',
    189: 'l_swedish',
    190: 'gui',
    191: 'graphics',
    192: 'orientation',
    193: 'checkbox',
    194: 'checkboxType',
    522: 'browserType',
    195: 'receiver',
    196: 'tickstamp',
    197: 'ordertype',
    198: 'server',
    199: 'client',
    200: 'commandlist',
    201: 'istargetasynchronous',
    202: 'port',
    203: 'string_address',
    204: 'session_name',
    205: 'status',
    206: 'address',
    207: 'basic_type',
    208: 'standardchatmessage',
    209: 'row',
    210: 'queryresult',
    211: 'requestlogin',
    212: 'loginresponce',
    213: 'password',
    214: 'loginclient',
    215: 'loginresult',
    216: 'logout',
    217: 'channel',
    218: 'type',
    219: 'channellistreply',
    220: 'request',
    221: 'handler',
    222: 'channellist',
    223: 'joinchannel',
    224: 'partchannel',
    225: 'user',
    226: 'message',
    227: 'chattext',
    228: 'distributechat',
    229: 'registeruser',
    230: 'key',
    231: 'registerresponce',
    232: 'game',
    233: 'verifieduser',
    234: 'verifiedpass',
    235: 'channeluserlist',
    236: 'userslist',
    237: 'chatuserschange',
    238: 'gamelistcommand',
    239: 'gamelist',
    240: 'announce',
    241: 'creator',
    242: 'removegame',
    243: 'joingame',
    244: 'identity',
    245: 'announcedone',
    246: 'launch',
    247: 'gamelaunched',
    248: 'ingamelogin',
    249: 'keepalive',
    250: 'updategame',
    251: 'loggedin',
    252: 'alluserlist',
    253: 'finduser',
    254: 'finduserresponce',
    255: 'banuser',
    256: 'notconnected',
    257: 'motd',
    258: 'updategamestatus',
    259: 'winner',
    260: 'drawers',
    261: 'win',
    262: 'loss',
    263: 'draw',
    264: 'finish',
    265: 'started',
    266: 'score',
    267: 'rank',
    268: 'ladder',
    269: 'datetime',
    270: 'dummy',
    271: 'sound_fx_volume',
    272: 'music_volume',
    273: 'scroll_speed',
    274: 'camera_rotation_speed',
    275: 'zoom_speed',
    276: 'mouse_speed',
    277: 'master_volume',
    278: 'version',
    279: 'executable',
    280: 'data',
    281: 'animatedType',
    282: 'requeststartown',
    283: 'startown',
    284: 'changeowner',
    285: 'newowner',
    286: 'vsync',
    287: 'debugmonitor',
    288: 'debug',
    289: 'pdxa',
    290: 'versionName',
    291: 'frames',
    292: 'frame',
    293: 'stance',
    294: 'indices',
    295: 'noOfTriangles',
    296: 'noOfVertices',
    297: 'vertices',
    298: 'l_italian',
    299: 'l_spanish',
    300: 'l_polish',
    301: 'textblock',
    302: 'systemmessage',
    303: 'personalmessage',
    304: 'requestusersgames',
    305: 'requestgame',
    306: 'sendgame',
    307: 'bodytexture',
    308: 'colortwo',
    309: 'static',
    310: 'animatedmaptext',
    311: 'maskedShieldType',
    312: 'spacing',
    313: 'membername',
    314: 'progressbartype',
    315: 'transparencecheck',
    316: 'soundeffect',
    317: 'pitch',
    318: 'pan',
    319: 'voicetype',
    320: 'soundeffects',
    321: 'upsound',
    322: 'downsound',
    323: 'oversound',
    324: 'clicksound',
    325: 'lockable',
    326: 'drag',
    327: 'volume',
    328: 'instantTextBoxType',
    329: 'shortcut',
    330: 'writetochatbuffer',
    331: 'chatbuffer',
    332: 'chatmessage',
    333: 'loadType',
    334: 'norefcount',
    335: 'bitmapfont',
    336: 'bitmapfonts',
    337: 'colorcodes',
    338: 'progressbar3dType',
    339: 'countrychat',
    340: 'locatorname',
    341: 'locatormatrix',
    342: 'adapter',
    343: 'gunSmoke',
    344: 'EffectStartFrame',
    345: 'starttransfer',
    346: 'sendchunk',
    347: 'chunkreceived',
    348: 'ledger_data',
    349: 'ledger_data_x',
    350: 'ledger_data_y',
    351: 'income_statistics',
    352: 'nation_size_statistics',
    353: 'inflation_statistics',
    354: 'offset',
    355: 'multisampling',
    356: 'anisotropicFiltering',
    357: 'upper',
    358: 'lower',
    359: 'allwaystransparent',
    360: 'threeDguiType',
    361: 'shadowSize',
    362: 'ambient_volume',
    363: 'luafunction_buttonclick',
    364: 'l_czech',
    365: 'l_hungarian',
    366: 'l_dutch',
    367: 'l_portugese',
    368: 'l_russian',
    369: 'l_finnish',
    370: 'EMFXActorType',
    371: 'actorfile',
    372: 'idle',
    373: 'attack',
    374: 'move',
    375: 'OverlappingElementsBoxType',
    376: 'luaClick',
    377: 'tileSpriteType',
    378: 'retargeting',
    379: 'attach',
    380: 'PieChartType',
    381: 'BarGraphType',
    382: 'billboardType',
    383: 'rotation',
    384: 'offset2',
    385: 'offset3',
    386: 'offset4',
    387: 'font_size',
    388: 'anisotropic_filtering',
    389: 'multi_sampling',
    390: 'scrollingSprite',
    391: 'node',
    392: 'attachId',
    393: 'rangeLimitMin',
    394: 'rangeLimitMax',
    395: 'rangeLimitMinIcon',
    396: 'rangeLimitMaxIcon',
    397: 'useRangeLimit',
    398: 'none',
    399: 'BarChartType',
    400: 'long_float',
    401: 'LineChartType',
    402: 'linewidth',
    403: 'flipu',
    404: 'flipv',
    405: 'pdx_tooltip',
    406: 'pdx_tooltip_delayed',
    407: 'use_animation',
    408: 'vertical',
    409: 'cull_distance',
    410: 'tilingCenter',
    411: 'color_override',
    412: 'first_on_top',
    413: 'path',
    414: 'dependencies',
    415: 'steam_id',
    416: 'pdx_id',
    417: 'archive',
    418: 'checksum',
    419: 'affects_checksum',
    420: 'has_set_language',
    421: 'click_to_front',
    422: 'gamersgate_id',
    423: 'replace_path',
    424: 'user_dir',
    425: 'pdxmesh',
    426: 'pdxparticle',
    427: 'diplomacy_construction',
    428: 'merchant_construction',
    429: 'chat_message',
    430: 'chat_user_joined',
    431: 'chat_user_left',
    432: 'chat_user_joined_channel',
    433: 'chat_user_left_channel',
    434: 'chat_new_channel',
    435: 'chat_close_channel',
    436: 'chat_sync',
    437: 'chat_request_sync',
    438: 'cursor',
    439: 'show_position',
    440: 'hide_position',
    441: 'animation_type',
    442: 'animation_time',
    443: 'accelerated',
    444: 'decelerated',
    445: 'smoothstep',
    446: 'linear',
    447: 'can_be_lowres',
    448: 'particle',
    449: 'subsystem',
    450: 'max_amount',
    451: 'emission',
    452: 'velocity',
    453: 'life',
    454: 'yaw',
    455: 'force',
    456: 'texture',
    457: 'end',
    458: 'amount',
    459: 'op',
    460: 'repeat',
    461: 'curve',
    462: 'z',
    463: 'w',
    464: 'alpha',
    465: 'time',
    466: 'mass',
    467: 'sort',
    468: 'invert',
    469: 'r',
    470: 'g',
    471: 'b',
    472: 'a',
    473: 'shader',
    474: 'roll',
    475: 'particle_pitch',
    476: 'particle_roll',
    477: 'frame_animation',
    478: 'animation_rate_fps',
    479: 'animation_rate_spf',
    480: 'looping',
    481: 'play_on_show',
    482: 'frameAnimatedSpriteType',
    483: 'tags',
    484: 'picture',
    486: 'check_sums',
    487: 'long_num',
    488: 'alwaystransparent',
    489: 'lazy_load',
    490: 'target_id',
    491: 'priority_shortcut',
    492: 'smoothListboxType',
    493: 'prepend',
    494: 'texturedLineType',
    495: 'take_events_when_disabled',
    496: 'dynamic_sound',
    497: 'dynamic_sound_treshold',
    498: 'supported_checksums',
    500: 'on_demand',
    501: 'pre_execution_checksums',
    502: 'post_execution_checksums',
    503: 'greater_eq',
    504: 'greater',
    505: 'less',
    506: 'less_eq',
    507: 'ignore_texture_existance',
    508: 'eq_eq',
    509: 'not_eq',
    510: 'scale_on_cull_distance',
    512: 'dlcs',
    513: 'categories',
    514: 'category',
    515: 'show_header',
    516: 'default_category',
    517: 'show_example_image',
    518: 'recommendations',
    519: 'interesting_characters',
    520: 'required_dlc',
    521: 'show_example_image_tooltips',
    523: 'hide_if_unowned',
    524: 'change_landingpage',
    525: 'hide_if_dlc_owned',
    526: 'gui_scale',
    527: 'gui_scale_min',
    528: 'gui_scale_max',
    529: 'gui_scale_font_replacement',
    530: 'fontname_gui_scaled',
    531: 'hide_scrollbar',
    532: 'scrollbar_offset',
    10000: 'opposites',
    10001: 'opinions',
    10002: 'fertility',
    10003: 'intrigue',
    10004: 'stewardship',
    10005: 'learning',
    10006: 'martial',
    10007: 'character',
    10008: 'traits',
    10009: 'character_event',
    10010: 'change_martial',
    10011: 'change_intrigue',
    10012: 'change_stewardship',
    10013: 'change_diplomacy',
    10014: 'change_learning',
    10015: 'add_trait',
    10016: 'remove_trait',
    10017: 'any_rival',
    10018: 'any_friend',
    10019: 'random_friend',
    10020: 'random_rival',
    10021: 'father',
    10022: 'mother',
    10023: 'wife',
    10024: 'birth',
    10025: 'trait',
    10026: 'birth_province',
    10027: 'employer_country',
    10028: 'add_friend',
    10029: 'remove_friend',
    10030: 'add_rival',
    10031: 'remove_rival',
    10032: 'add_spouse',
    10033: 'remove_spouse',
    10034: 'add_child',
    10035: 'remove_child',
    10036: 'birth_date',
    10037: 'wealth_change',
    10038: 'dynasty',
    10039: 'sibling',
    10040: 'spouse',
    10041: 'wealth',
    10042: 'friends',
    10043: 'rivals',
    10044: 'job',
    10045: 'unborn',
    10046: 'employer',
    10047: 'death',
    10048: 'attributes',
    10049: 'conquered',
    10050: 'last_ruler_term',
    10051: 'holder',
    10052: 'dynasties',
    10053: 'inbred',
    10054: 'bastard',
    10055: 'gender',
    10056: 'pat_grf_name_chance',
    10057: 'mat_grf_name_chance',
    10058: 'father_name_chance',
    10059: 'pat_grm_name_chance',
    10060: 'mat_grm_name_chance',
    10061: 'mother_name_chance',
    10062: 'piety',
    10063: 'is_priest',
    10064: 'can_marry',
    10065: 'is_pregnant',
    10066: 'any_courtier',
    10067: 'base_health',
    10068: 'message_interest',
    10069: 'no_message_interest',
    10070: 'child',
    10071: 'create_character',
    10072: 'new_character',
    10073: 'create_random_priest',
    10074: 'create_random_soldier',
    10075: 'create_random_steward',
    10076: 'create_random_intriguer',
    10077: 'create_random_diplomat',
    10078: 'placeholder',
    10079: 'provinceType',
    10080: 'provinceBorderType',
    10081: 'flagType',
    10082: 'shieldtype',
    10083: 'eu3dialogtype',
    10084: 'provinceWaterType',
    10085: 'constructbuilding',
    10086: 'projectionType',
    10087: 'pulsating',
    10088: 'additative',
    10089: 'expanding',
    10090: 'pulseLowest',
    10091: 'pulseSpeed',
    10092: 'spin',
    10093: 'fadeout',
    10094: 'mapRenderingOptions',
    10095: 'renderTrees',
    10096: 'bookmark',
    10097: 'selectbookmark',
    10098: 'clearbookmark',
    10099: 'loadgame',
    10100: 'loadgamestart',
    10101: 'lastplayer',
    10102: 'lasthost',
    10103: 'serveradress',
    10104: 'resetgame',
    10105: 'setdifficulty',
    10106: 'outliner',
    10107: 'confirm',
    10108: 'windowmovetime',
    10109: 'radialstaytime',
    10110: 'provinces',
    10111: 'max_provinces',
    10112: 'definitions',
    10113: 'maptype',
    10114: 'testmap',
    10115: 'history',
    10116: 'base_tax',
    10117: 'culture',
    10118: 'primary_culture',
    10119: 'accepted_culture',
    10120: 'add_accepted_culture',
    10121: 'remove_accepted_culture',
    10122: 'allowed_conversion',
    10123: 'religion',
    10124: 'manpower',
    10125: 'monarch',
    10126: 'owner',
    10127: 'controller',
    10128: 'occupier',
    10129: 'province',
    10130: 'conquercommand',
    10131: 'base_price',
    10132: 'max_demand',
    10133: 'min_demand',
    10134: 'trade_goods',
    10135: 'goldtype',
    10136: 'plantation',
    10137: 'yes',
    10138: 'no',
    10139: 'date',
    10140: 'capital',
    10141: 'hre',
    10142: 'prerequisites',
    10143: 'not_if_x_exists',
    10144: 'building',
    10145: 'leader_names',
    10146: 'monarch_names',
    10147: 'core',
    10148: 'add_core',
    10149: 'remove_core',
    10150: 'cost',
    10151: 'build_cost',
    10152: 'build_time',
    10153: 'revolt_risk',
    10154: 'local_revolt_risk',
    10155: 'global_revolt_risk',
    10156: 'terrain',
    10157: 'terrain_definition',
    10158: 'movement_cost',
    10159: 'left_specific',
    10160: 'right_specific',
    10161: 'average_year',
    10162: 'technology',
    10163: 'technology_group',
    10164: 'tables',
    10165: 'groups',
    10166: 'adm_efficiency',
    10167: 'government',
    10168: 'enroute',
    10169: 'stagnation',
    10170: 'success',
    10171: 'level',
    10172: 'location',
    10173: 'stagnated',
    10174: 'ledger',
    10175: 'treasury',
    10176: 'current_income',
    10177: 'current_expense',
    10178: 'distribution',
    10179: 'lastmonthincome',
    10180: 'lastmonthexpense',
    10181: 'lastmonthincometable',
    10182: 'lastmonthexpensetable',
    10183: 'lastyearincome',
    10184: 'lastyearexpense',
    10185: 'income',
    10186: 'expense',
    10187: 'thismonthincome',
    10188: 'thismonthexpense',
    10189: 'local_tax_modifier',
    10190: 'global_tax_modifier',
    10191: 'tax_income',
    10192: 'stability',
    10193: 'stability_investment',
    10194: 'stability_cost',
    10195: 'stability_cost_modifier',
    10196: 'militia',
    10197: 'heavy_infantry',
    10198: 'cavalry',
    10200: 'archers',
    12254: 'special_troops',
    10201: 'warelephant',
    10202: 'trireme',
    10203: 'enable',
    10204: 'maneuver',
    10205: 'heavy_infantry_cost',
    10207: 'archers_cost',
    10208: 'heavy_infantry_morale',
    10209: 'heavy_infantry_offensive',
    10210: 'heavy_infantry_defensive',
    10214: 'archers_morale',
    10215: 'archers_offensive',
    10216: 'archers_defensive',
    10217: 'country',
    10218: 'altitude',
    10219: 'heightmap',
    10220: 'army',
    10221: 'navy',
    10222: 'regiment',
    10223: 'ship',
    10224: 'home',
    10225: 'move_order',
    10226: 'unit',
    10227: 'movement_progress',
    10228: 'morale',
    10229: 'strength',
    10230: 'DIP',
    10231: 'MIL',
    10232: 'ADM',
    10233: 'lender',
    10234: 'expiry_date',
    10235: 'cancel_movement',
    10236: 'is_water',
    10237: 'siege',
    10238: 'manuever',
    10239: 'leader',
    10240: 'admiral',
    10241: 'explorer',
    10242: 'conquistador',
    10243: 'general',
    10244: 'has_texture',
    10245: 'activation',
    10246: 'create_leader',
    10247: 'building_construction',
    10248: 'military_construction',
    10249: 'local_population_growth',
    10250: 'global_population_growth',
    10251: 'daily_tick',
    10252: 'sea_starts',
    10253: 'skill',
    10254: 'increase_game_speed',
    10255: 'decrease_game_speed',
    10256: 'alliance',
    10257: 'guarantee',
    10258: 'royal_marriage',
    10259: 'union',
    10260: 'vassal',
    10261: 'first',
    10262: 'second',
    10263: 'start_date',
    10264: 'last_start_date',
    10265: 'end_date',
    10266: 'tree',
    10267: 'tree_definition',
    10268: 'tree_density',
    10269: 'cancel',
    10270: 'city',
    10271: 'positions',
    10272: 'diplomacy',
    10273: 'casus_belli',
    10274: 'value',
    10275: 'graphical_culture',
    10276: 'add_attacker',
    10277: 'rem_attacker',
    10278: 'add_defender',
    10279: 'rem_defender',
    10280: 'battle',
    10281: 'attackers',
    10282: 'defenders',
    10283: 'active_war',
    10284: 'previous_war',
    10285: 'attacker',
    10286: 'defender',
    10287: 'result',
    10288: 'losses',
    10289: 'rivers',
    10290: 'land_morale',
    10291: 'naval_morale',
    10292: 'index',
    10293: 'land_maintenance',
    10294: 'naval_maintenance',
    10295: 'change_maintenance',
    10296: 'change_investment',
    10297: 'combat',
    10298: 'phase',
    10299: 'dice',
    10300: 'land_combat',
    10301: 'naval_combat',
    10302: 'siege_combat',
    10303: 'sprite_level',
    10304: 'buildunit',
    10305: 'changetolerance',
    10306: 'retreat',
    10307: 'claimdefender',
    10308: 'convert',
    10309: 'attrition',
    10310: 'max_attrition',
    10311: 'supply_limit',
    10312: 'looted',
    10313: 'breach',
    10314: 'garrison',
    10315: 'assault',
    10316: 'blockade',
    10317: 'changefog',
    10318: 'last_control_change',
    10319: 'actor',
    10320: 'recipient',
    10321: 'rebel',
    10322: 'diplomaticactioncommand',
    10323: 'action',
    10324: 'military_access',
    10325: 'elector',
    10326: 'republican_name',
    10327: 'declarewar',
    10328: 'requestpeace',
    10329: 'allianceaction',
    10330: 'embargoaction',
    10331: 'annexationaction',
    10332: 'vassalaction',
    10333: 'guaranteeaction',
    10334: 'warningaction',
    10335: 'milaccess',
    10336: 'offermilaccess',
    10337: 'port_rotation',
    10338: 'opennegotiation',
    10339: 'insultaction',
    10340: 'giftaction',
    10341: 'claimaction',
    10342: 'last_war',
    10343: 'last_send_diplomat',
    10344: 'callaction',
    10345: 'versus',
    10346: 'continent',
    10347: 'overseas_income',
    10348: 'leader_siege',
    10349: 'change_prefered_unit',
    10350: 'may_explore',
    10351: 'convert_king',
    10352: 'leader_naval_manuever',
    10353: 'fort_level',
    10354: 'luck',
    10355: 'badboy',
    10356: 'badboy_limit',
    10357: 'event',
    10358: 'tech_change',
    10359: 'trigger',
    10360: 'mean_time_to_happen',
    10361: 'weight_multiplier',
    10362: 'modifier',
    10363: 'option',
    10364: 'ai_chance',
    10365: 'and',
    10366: 'or',
    10367: 'not',
    10368: 'factor',
    10369: 'months',
    10370: 'days',
    10371: 'years',
    10372: 'shield3dType',
    10373: 'num_of_monopolys',
    10374: 'owns',
    10375: 'controls',
    10376: 'is_core',
    10377: 'num_of_revolts',
    10378: 'revolt_percentage',
    10379: 'num_of_cities',
    10380: 'num_of_ports',
    10381: 'is_monarch_leader',
    10382: 'defender_of_faith',
    10383: 'num_of_allies',
    10384: 'num_of_royal_marriages',
    10385: 'num_of_vassals',
    10386: 'num_of_unions',
    10387: 'num_of_electors',
    10388: 'num_of_religion',
    10389: 'religion_group',
    10390: 'war',
    10391: 'createvassal',
    10392: 'from',
    10393: 'to',
    10394: 'title',
    10395: 'desc',
    10396: 'select_event_option',
    10397: 'scope',
    10398: 'seed',
    10399: 'historical_units',
    10400: 'death_date',
    10401: 'ally',
    10402: 'exists',
    10403: 'change_tag',
    10404: 'culture_group',
    10405: 'prestige',
    10406: 'difficulty',
    10407: 'add_province_modifier',
    10408: 'add_country_modifier',
    10409: 'ship_names',
    10410: 'previous',
    10411: 'is_religion_enabled',
    10412: 'enable_religion',
    10413: 'messageclass',
    10414: 'log',
    10415: 'onmap',
    10416: 'popup',
    10417: 'needaccept',
    10418: 'cb_on_religious_enemies',
    10419: 'country_event',
    10420: 'province_event',
    10421: 'any_neighbor_province',
    10422: 'any_neighbor_country',
    10423: 'relation',
    10424: 'who',
    10425: 'this',
    10426: 'root',
    10427: 'prev',
    10428: 'has_country_flag',
    10429: 'set_country_flag',
    10430: 'clr_country_flag',
    10431: 'has_title_flag',
    10432: 'set_title_flag',
    10433: 'clr_title_flag',
    10434: 'flags',
    10435: 'disband_unit',
    10436: 'disband_regiment',
    10437: 'merge_units',
    10438: 'reinforce',
    10439: 'transfer_subunit',
    10440: 'sub_unit',
    10441: 'set_controller',
    10442: 'clear_all_controllers',
    10443: 'machine',
    10444: 'create_unit',
    10445: 'manufactory',
    10446: 'sethistoricaldate',
    10447: 'startgame',
    10448: 'quit',
    10449: 'terms',
    10450: 'demand',
    10451: 'releasevassal',
    10452: 'rename_unit',
    10453: 'rename_sub_unit',
    10454: 'front',
    10455: 'back',
    10456: 'reserves',
    10457: 'addplayer',
    10458: 'other',
    10459: 'positioning',
    10460: 'annex',
    10461: 'playerconnected',
    10462: 'economy',
    10463: 'military',
    10464: 'count',
    10465: 'setrandom',
    10466: 'pausegame',
    10467: 'assign_leader',
    10468: 'staging_province',
    10469: 'invasion',
    10470: 'client_only',
    10471: 'clear',
    10472: 'transport',
    10473: 'transport_fraction',
    10474: 'transport_cost',
    10475: 'owned_by',
    10476: 'garrison_growth',
    10477: 'set_province_flag',
    10478: 'clr_province_flag',
    10479: 'has_province_flag',
    10480: 'adjacencies',
    10481: 'better',
    10482: 'create_succession_war',
    10483: 'succession',
    10484: 'regent',
    10485: 'create_revolt',
    10486: 'capital_scope',
    10487: 'warning',
    10488: 'has_building',
    10489: 'add_building',
    10490: 'remove_building',
    10491: 'tag',
    10492: 'knows_country',
    10493: 'monthly_income',
    10494: 'secede_province',
    10495: 'inherit',
    10496: 'release',
    10497: 'mercenary',
    10498: 'add_casus_belli',
    10499: 'inland_sea',
    10500: 'limit',
    10501: 'any_country',
    10502: 'random_country',
    10503: 'random_demesne_province',
    10504: 'neighbour',
    10505: 'regency',
    10506: 'city_nudge',
    10507: 'manufactory_nudge',
    10508: 'trade_nudge',
    10509: 'total',
    10510: 'text_position',
    10511: 'text_rotation',
    10512: 'female',
    10513: 'direct_tax_percentage',
    10514: 'text_scale',
    10515: 'boost',
    10516: 'tropical',
    10517: 'mild_winter',
    10518: 'normal_winter',
    10519: 'severe_winter',
    10520: 'climate',
    10521: 'winter',
    10522: 'autosave',
    10523: 'color1',
    10524: 'color2',
    10525: 'color3',
    10526: 'sellprov',
    10527: 'subsidies',
    10528: 'sea_zone',
    10529: 'create_pirate',
    10530: 'has_province_modifier',
    10531: 'has_country_modifier',
    10532: 'last_command_date',
    10533: 'previous_monarch',
    10534: 'units_in_province',
    10535: 'galleys_in_province',
    10536: 'war_with',
    10537: 'unit_in_battle',
    10538: 'unit_in_siege',
    10539: 'infantry_in_province',
    10540: 'unit_has_leader',
    10541: 'player',
    10542: 'change_controller',
    10543: 'estimated_monthly_income',
    10544: 'estimated_monthly_expense',
    10545: 'doautosave',
    10546: 'at_sea',
    10547: 'arrow_state',
    10548: 'image',
    10549: 'replace',
    10550: 'extend',
    10551: 'reduced_naval_attrition',
    10552: 'technology_cost',
    10553: 'plantation_demand',
    10554: 'simpleWater',
    10555: 'has_siege',
    10556: 'change_siege',
    10557: 'minimum_revolt_risk',
    10558: 'ai_will_do',
    10559: 'random_neighbor_province',
    10560: 'pure_revolt_risk',
    10561: 'split',
    10562: 'population',
    10563: 'allow_unit_type',
    10564: 'research_points_modifier',
    10565: 'local_research_points_modifier',
    10566: 'tech_growth_modifier',
    10567: 'tech_growth_modifier_military',
    10568: 'tech_growth_modifier_economy',
    10569: 'tech_growth_modifier_culture',
    10570: 'from_country',
    10571: 'from_province',
    10572: 'is_triggered_only',
    10573: 'which',
    10574: 'any_owned',
    10575: 'remove_province_modifier',
    10576: 'remove_holding_modifier',
    10577: 'remove_country_modifier',
    10578: 'from_character',
    10579: 'multiplier',
    10580: 'ruler',
    10581: 'tribal',
    10582: 'monarchy',
    10583: 'republic',
    10584: 'invention',
    10585: 'appoint_to_office',
    10586: 'active_inventions',
    10587: 'possible_inventions',
    10588: 'illegal_inventions',
    10589: 'lose_invention',
    10590: 'call_omen',
    10591: 'omen',
    10592: 'omen_power',
    10593: 'omen_chance',
    10594: 'omen_start',
    10595: 'male',
    10596: 'male_names',
    10597: 'female_names',
    10598: 'family',
    10599: 'nickname',
    10600: 'female_order',
    10601: 'local_defensive',
    10602: 'global_defensive',
    10603: 'ruler_popularity_gain',
    10604: 'monthly_character_loyalty',
    10605: 'monthly_character_wealth',
    10606: 'monthly_character_popularity',
    10607: 'freedmen_to_citizen',
    10608: 'slaves_to_freedmen',
    10609: 'regiment_reinforcement_speed',
    10610: 'land_organisation',
    10611: 'naval_organisation',
    10612: 'siege_speed',
    10613: 'corruption',
    10614: 'action_cost',
    10615: 'omen_failure_penalty',
    10616: 'religious_spread',
    10617: 'is_governor',
    10618: 'has_governor',
    10619: 'governor',
    10620: 'any_province',
    10621: 'any_character',
    10622: 'move_character',
    10623: 'random_character',
    10624: 'check_variable',
    10625: 'set_variable',
    10626: 'change_variable',
    10627: 'variables',
    10628: 'is_rival',
    10629: 'is_friend',
    10630: 'num_of_rivals',
    10631: 'num_of_friends',
    10632: 'is_female',
    10633: 'age',
    10634: 'family_prestige',
    10635: 'has_office',
    10636: 'in_command',
    10637: 'is_ruler',
    10638: 'is_married',
    10639: 'num_of_traits',
    10640: 'any_child',
    10641: 'assign_office',
    10642: 'random_empty_neighbor_province',
    10643: 'any_empty_neighbor_province',
    10644: 'create_colony',
    10645: 'random',
    10646: 'random_list',
    10647: 'change_unit_allegiance',
    10648: 'ai',
    10649: 'prisoner',
    10650: 'is_envoy',
    10651: 'has_empty_adjacent_province',
    10652: 'chance',
    10653: 'governor_scope',
    10654: 'health',
    10655: 'has_character_flag',
    10656: 'set_character_flag',
    10657: 'clr_character_flag',
    10658: 'remove_regiment',
    10659: 'consolidate',
    10660: 'rally',
    10661: 'envelope',
    10662: 'wedge',
    10663: 'hold_ground',
    10664: 'force_attack',
    10665: 'num_of_children',
    10666: 'remove_governor',
    10667: 'random_child',
    10668: 'is_capital',
    10669: 'state',
    10670: 'has_job',
    10671: 'send_colonist',
    10672: 'char',
    10673: 'unemployed',
    10674: 'controlled_by',
    10675: 'navy_size_percentage',
    10676: 'army_size_percentage',
    10677: 'at_location',
    10678: 'remove_from_unit',
    10679: 'assign_to_unit',
    10680: 'has_unassigned_unit',
    10681: 'immediate',
    10682: 'province_id',
    10683: 'region',
    10684: 'trading_with',
    10685: 'has_owner',
    10686: 'castle',
    10687: 'temple',
    10688: 'landed_title',
    10689: 'trade_post',
    10690: 'settlement',
    10691: 'is_clan_leader',
    10692: 'historical_law',
    10693: 'texture_internal',
    10694: 'template',
    10696: 'defence',
    10697: 'scaled_wealth',
    10698: 'toggle_feature',
    10699: 'add_protected',
    10700: 'remove_protected',
    10701: 'disallow_events_for_player',
    10702: 'allow_events_for_player',
    10703: 'show_window',
    10704: 'hide_window',
    10705: 'story',
    10706: 'story_position',
    10707: 'has_story',
    10708: 'song',
    10709: 'active',
    10710: 'activate_title',
    10711: 'is_title_active',
    10712: 'possible',
    10713: 'happened',
    10714: 'achievement',
    10715: 'disable_wikipedia_links',
    10716: 'any_claim',
    10717: 'random_claim',
    10718: 'num_of_claims',
    10719: 'rightful_religious_head',
    10720: 'rightful_religious_head_scope',
    10721: 'relative_power_to_liege',
    10722: 'num_of_king_titles',
    10723: 'destroy_random_building',
    10724: 'num_of_buildings',
    10725: 'allow_alerts',
    10726: 'allow_tooltips',
    10727: 'in_battle',
    10728: 'in_siege',
    10729: 'set_father',
    10730: 'set_mother',
    10731: 'prevprevprev',
    10732: 'prevprevprevprev',
    10733: 'reduce_disease',
    10734: 'clear_wealth',
    10735: 'send_assassin',
    10736: 'father_even_if_dead',
    10737: 'mother_even_if_dead',
    10738: 'any_ward',
    10739: 'random_ward',
    10740: 'namespace',
    10741: 'settlement_age',
    10742: 'spouse_even_if_dead',
    10743: 'lover',
    10744: 'has_lover',
    10745: 'add_lover',
    10746: 'remove_lover',
    12340: 'subtract_variable',
    12341: 'multiply_variable',
    12342: 'divide_variable',
    10747: 'pausepopup',
    10748: 'sound',
    10749: 'distance',
    10750: 'where',
    10751: 'special',
    10752: 'cached',
    10753: 'discovercommand',
    10754: 'BannerType',
    10755: 'polefile',
    10756: 'flagfile',
    10757: 'trade',
    10758: 'dont_track_data',
    10759: 'cancel_job_action',
    10760: 'has_made_data_tracking_choice',
    10761: 'kill',
    10762: 'tribute',
    10763: 'tribe',
    10764: 'pre_reformed',
    10765: 'intermarry',
    10766: 'refill_holding_levy',
    10767: 'demandtributeaction',
    10768: 'offertributeaction',
    10769: 'apply_long_occ_mod',
    10770: 'apply_short_occ_mod',
    10771: 'assassinate',
    10772: 'supportrebels',
    10773: 'children',
    10774: 'diplomat',
    10775: 'is_prisoner',
    10776: 'prisoner_home',
    10777: 'imprisoned',
    10778: 'ransom',
    10779: 'historical',
    10780: 'country_job',
    10781: 'province_job',
    10782: 'unit_job',
    10783: 'diplo_job',
    10784: 'null_job',
    10785: 'cancel_unit',
    10786: 'flag',
    10787: 'hair',
    10788: 'mouth',
    10789: 'chin',
    10790: 'nose',
    10791: 'eyes',
    10792: 'cheeks',
    10793: 'ears',
    10794: 'neck',
    10795: 'portraitType',
    10796: 'dna',
    10797: 'route',
    10798: 'weak',
    10799: 'rebels',
    10800: 'strong',
    10801: 'race',
    10802: 'pacifist',
    10803: 'aggression',
    10804: 'make_primary_title',
    10805: 'any_previous_holder',
    10806: 'female_temple_holders',
    10807: 'peace_prestige_loss',
    10808: 'raised_vassal_opinion_loss',
    10809: 'independence_war_score_bonus',
    10810: 'rebel_colors',
    10811: 'autocephaly',
    10812: 'patrician_heir',
    10813: 'player_allow',
    10814: 'random_trade_post',
    10815: 'any_trade_post',
    10816: 'is_claim_all',
    10817: 'is_adult',
    10818: 'is_marriage_adult',
    10819: 'embark_army',
    10820: 'siege_nudge',
    10821: 'last_victory',
    10822: 'last_stability_boost',
    10823: 'mercenary_fraction',
    10824: 'held_title_rating',
    10825: 'can_recruit_mercenaries',
    10826: 'can_retire_to_monastery',
    10827: 'merc_cavalry',
    10828: 'merc_militia',
    10829: 'merc_heavy_infantry',
    10830: 'merc_horse_archers',
    10831: 'merc_archers',
    10832: 'merc_warelephant',
    10833: 'any_garrisoned_province',
    10834: 'disband_non_loyal_mercenaries',
    10835: 'disband_event_forces',
    10836: 'random_garrisoned_province',
    10837: 'is_land',
    10838: 'remove_fleet',
    10839: 'can_build',
    10840: 'has_more_wealth_than_ruler',
    10841: 'has_more_prestige_than_ruler',
    10842: 'from_ruler_dynasty',
    10843: 'random_sibling',
    10844: 'religion_power',
    10845: 'religious',
    10846: 'set_ruler',
    10847: 'averaged_income',
    10848: 'yearly_income',
    10849: 'random_sea_province',
    10850: 'is_at_sea',
    10851: 'any_sea_province',
    10852: 'previous_ruler',
    10853: 'is_valid_viking_invasion_target',
    10854: 'reduce_character_popularity',
    10855: 'reduce_character_loyalty',
    10856: 'country_regions',
    10857: 'allow',
    10858: 'parent_scope',
    10859: 'finished_date',
    10860: 'cancel_mission_command',
    10861: 'reform_religion_command',
    10862: 'our_provinces',
    10863: 'neighbor_provinces',
    10864: 'empty_provinces',
    10865: 'sea_zones',
    10866: 'neighbor_countries',
    10867: 'war_countries',
    10868: 'enemy_provinces',
    10869: 'abort',
    10870: 'active_mission',
    10871: 'active_objective',
    10872: 'active_plot',
    10873: 'active_ambition',
    10874: 'active_faction',
    10875: 'activate_plot',
    10876: 'add_plot',
    10877: 'has_plot',
    10878: 'cancel_plot',
    10879: 'add_ambition',
    10880: 'has_ambition',
    10881: 'cancel_ambition',
    10882: 'is_general',
    10883: 'is_admiral',
    10884: 'is_capital_region',
    10885: 'capital_holding',
    10886: 'major_trigger',
    10887: 'dismiss_trigger',
    10888: 'lose_trigger',
    10889: 'lose_effect',
    10890: 'pass_effect',
    10891: 'dismissal_trigger',
    10892: 'dismissal_effect',
    10893: 'gain_effect',
    10894: 'has_job_title',
    10895: 'give_job_title',
    10896: 'has_minor_title',
    10897: 'give_minor_title',
    10898: 'remove_title',
    10899: 'full_term',
    10900: 'election_delay',
    10901: 'gain_trigger',
    10902: 'always',
    10903: 'party',
    10904: 'courtier',
    10905: 'is_councillor',
    10906: 'completed_objective',
    10907: 'appoint_to_court',
    10908: 'is_clan_chief',
    10909: 'clan_chief',
    10910: 'last_mission_cancel',
    10911: 'last_mission',
    10912: 'fail_effect',
    10913: 'potential',
    10914: 'decisions',
    10915: 'laws',
    10916: 'execute_decision_command',
    10917: 'revoke_decision_command',
    10918: 'decision',
    10919: 'revoke_effect',
    10920: 'law',
    10921: 'ai_will_revoke',
    10922: 'ai_capital_kingdom_focus',
    10923: 'toggle_prison_command',
    10924: 'execute_character_command',
    10925: 'banish_character_command',
    10926: 'home_country',
    10927: 'assassinate_character_command',
    10928: 'smear_character_command',
    10929: 'bribe_character_command',
    10930: 'add_character_message_interest_command',
    10931: 'create_character_for_barony',
    10932: 'grantable',
    10933: 'grant_limit',
    10934: 'grant_trigger',
    10935: 'has_law',
    10936: 'add_law',
    10937: 'revoke_law',
    10938: 'revoke_allowed',
    10939: 'creation_requires_capital',
    10940: 'base',
    10941: 'grant_title_command',
    10942: 'alliance_with',
    10943: 'any_sibling',
    10944: 'any_spouse',
    10945: 'any_spouse_even_if_dead',
    10946: 'random_spouse',
    10947: 'is_main_spouse',
    10948: 'siblings',
    10949: 'banish',
    10950: 'banish_religion',
    10951: 'expel_modifier',
    10952: 'is_banished',
    10953: 'major',
    10954: 'retreat_delay',
    10955: 'is_alive',
    10956: 'cognatic',
    10957: 'current_heir',
    10958: 'preferred_heir',
    10959: 'ruling_party',
    10960: 'is_primary_heir',
    10961: 'empty',
    10962: 'any_dynasty_member',
    10963: 'can_hold_title',
    10964: 'ai_hard_strategy',
    10965: 'balanced',
    10966: 'initialized',
    10967: 'colonize_prov',
    10968: 'conquer_prov',
    10969: 'building_prov',
    10970: 'raid_prov',
    10971: 'threat',
    10972: 'antagonize',
    10973: 'befriend',
    10974: 'rival',
    10975: 'rival_countries',
    10976: 'threat_countries',
    10977: 'is_rival_country',
    10978: 'is_threat_country',
    10979: 'protect',
    10980: 'has_tech_office',
    10981: 'is_previous_ruler',
    10982: 'congenital',
    10983: 'is_pretender',
    10984: 'is_bastard',
    10985: 'colony',
    10986: 'adjective',
    10987: 'country_name',
    10988: 'country_adjective',
    10989: 'marriage_command',
    10990: 'arranged_marriages',
    10991: 'events',
    10992: 'random_events',
    10993: 'pirate',
    10994: 'liege',
    10995: 'tier',
    10996: 'claim',
    10997: 'prefix',
    10998: 'male_patronym',
    10999: 'female_patronym',
    11000: 'heretic',
    11001: 'has_heresies',
    11002: 'demesne',
    11003: 'player_realm',
    11004: 'relations',
    11005: 'priest',
    11006: 'from_dynasty_prefix',
    11007: 'from_dynasty_suffix',
    11008: 'bastard_dynasty_prefix',
    11009: 'founder_named_dynasties',
    11010: 'max_settlements',
    11011: 'settlement_construction',
    11012: 'levy_size',
    11013: 'feudal_elective',
    11014: 'tanistry',
    11015: 'gavelkind',
    11016: 'seniority',
    11017: 'primogeniture',
    11018: 'turkish_succession',
    11019: 'open_elective',
    11020: 'catholic_bishopric',
    11021: 'patrician_elective',
    11022: 'ultimogeniture',
    11023: 'appointment',
    11024: 'is_patrician',
    11025: 'is_merchant_republic',
    11026: 'mask',
    11027: 'layer',
    11028: 'CoatOfArmsType',
    11029: 'textures',
    11030: 'colors',
    11031: 'succession_laws',
    11032: 'gender_laws',
    11033: 'de_jure_laws',
    11034: 'city_tax_modifier',
    11035: 'castle_tax_modifier',
    11036: 'temple_tax_modifier',
    11037: 'trade_post_tax_modifier',
    11038: 'num_of_trade_posts',
    11039: 'num_of_trade_post_diff',
    11040: 'republic_total_num_of_trade_posts',
    11041: 'num_culture_realm_provs',
    11042: 'num_religion_realm_provs',
    11043: 'num_title_realm_provs',
    11044: 'templates',
    11045: 'can_lead_troops',
    11046: 'local_build_time_modifier',
    11047: 'local_build_cost_modifier',
    11048: 'attribute',
    11049: 'emblem',
    11050: 'noOfEmblem',
    11051: 'coat_of_arms',
    11052: 'title_female',
    11053: 'job_title',
    11054: 'abroad',
    11055: 'host',
    11056: 'hair_color',
    11057: 'hair_color_index',
    11058: 'eye_color',
    11059: 'eye_color_index',
    11060: 'vassals',
    11061: 'character_action',
    11062: 'is_feudal',
    11063: 'is_theocracy',
    11064: 'is_republic',
    11065: 'character_interaction_command',
    11066: 'imprison_character_interaction',
    11067: 'release_from_prison_interaction',
    11068: 'execute_imprisoned_interaction',
    11069: 'exile_imprisoned_interaction',
    11070: 'retire_to_monastery_interaction',
    11071: 'release_vassal_interaction',
    11072: 'ask_to_embargo_interaction',
    11073: 'demand_religious_conversion_interaction',
    11074: 'transfer_vassal_interaction',
    11075: 'create_title_interaction',
    11076: 'claim_title_interaction',
    11077: 'revoke_title_interaction',
    11078: 'usurp_title_interaction',
    11079: 'award_honorary_title_interaction',
    11080: 'send_assassin_interaction',
    11081: 'declare_war_interaction',
    11082: 'offer_peace_interaction',
    11083: 'send_gift_interaction',
    11084: 'offer_alliance_interaction',
    11085: 'cancel_alliance_interaction',
    11086: 'offer_vassalization_interaction',
    11087: 'ask_for_vassalization_interaction',
    11088: 'arrange_betrothal_interaction',
    11089: 'break_betrothal_interaction',
    11090: 'offer_succession_marrige_interaction',
    11091: 'offer_marrige_interaction',
    11092: 'ransom_character_interaction',
    11093: 'invite_to_court_interaction',
    11094: 'ask_to_join_war_interaction',
    11095: 'properties',
    11096: 'education',
    11097: 'guardian',
    11098: 'educate_character_interaction',
    11099: 'viceroy',
    11100: 'incapacitating',
    11101: 'pilgrimage',
    11102: 'opinion',
    11103: 'monthly_character_prestige',
    11104: 'monthly_character_piety',
    11105: 'personality',
    11106: 'thirdparty',
    11107: 'minor_title',
    11108: 'betrothal',
    11109: 'investiture',
    11110: 'foa',
    11111: 'landless',
    11112: 'controls_religion',
    11113: 'caliphate',
    11114: 'independent',
    11115: 'primary',
    11116: 'is_primary_type_title',
    11117: 'is_landless_type_title',
    11118: 'is_tribal_type_title',
    11119: 'crusade_name',
    11120: 'last_crusade',
    11121: 'can_excommunicate',
    11122: 'can_grant_divorce',
    11123: 'can_grant_invasion_cb',
    11124: 'can_grant_claim',
    11125: 'can_call_crusade',
    11126: 'has_coa_on_barony_only',
    11127: 'plot_backers',
    11128: 'any_plot_backer',
    11129: 'any_faction_backer',
    11130: 'backer',
    11131: 'plot',
    11132: 'faction',
    11133: 'known',
    11134: 'has_landed_title',
    11135: 'their_opinion',
    11136: 'on_add',
    11137: 'on_success',
    11138: 'on_fail',
    11139: 'on_reverse_demand',
    11140: 'on_add_title',
    11141: 'on_success_title',
    11142: 'on_fail_title',
    11143: 'on_reverse_demand_title',
    11144: 'is_valid_title',
    11145: 'is_valid',
    11146: 'personality_traits',
    11147: 'congenital_traits',
    11148: 'lifestyle_traits',
    11149: 'health_traits',
    11150: 'num_traits',
    11151: 'lifestyle',
    11152: 'is_health',
    11153: 'liege_titles',
    11154: 'liege_titles_w_claimant',
    11155: 'has_claim',
    11156: 'has_strong_claim',
    11157: 'has_weak_claim',
    11158: 'add_claim',
    11159: 'add_weak_claim',
    11160: 'add_pressed_claim',
    11161: 'add_weak_pressed_claim',
    11162: 'remove_claim',
    11163: 'claimed_by',
    11164: 'is_claim_cb',
    11165: 'war_name',
    11166: 'baron',
    11167: 'duke',
    11168: 'king',
    11169: 'emperor',
    11170: 'realm',
    11171: 'holder_scope',
    11172: 'wanted_title',
    11173: 'border',
    11174: 'narrative_event',
    11175: 'delayed_event',
    11176: 'gold_offered',
    11177: 'gold_demanded',
    11178: 'peace_offer',
    11179: 'primary_title',
    11180: 'from_title',
    11181: 'de_jure_liege',
    11182: 'de_facto_liege',
    11183: 'realm_characters',
    11184: 'realm_characters_plus',
    11185: 'plot_target_char',
    11186: 'plot_target_title',
    11187: 'plot_target_province',
    11188: 'inherit_title',
    11189: 'grant_title',
    11190: 'grant_title_no_opinion',
    11191: 'gain_title',
    11192: 'is_primary_holder_title',
    11193: 'property_weights',
    11194: 'would_be_heir_under_law',
    11195: 'heir_under_seniority_law',
    11196: 'heir_under_primogeniture_law',
    11197: 'heir_under_ultimogeniture_law',
    11198: 'auto',
    11199: 'realm_in_name',
    11200: 'dignity',
    11201: 'vassal_of',
    11202: 'overlord_of',
    11203: 'is_permanent',
    11204: 'other_de_jure_claim',
    11205: 'crownlaw_title',
    11206: 'dejure_liege_title',
    11207: 'gain_all_occupied_titles',
    11208: 'voter',
    11209: 'nominee',
    11210: 'nomination',
    11211: 'nominate_successor_command',
    11212: 'ai_zeal',
    11213: 'ai_ambition',
    11214: 'ai_honor',
    11215: 'ai_rationality',
    11216: 'ai_greed',
    11217: 'is_mother',
    11218: 'is_father',
    11219: 'is_guardian',
    11220: 'is_liege_of',
    11221: 'letter_event',
    11222: 'old_holding',
    11223: 'from_scope',
    11224: 'from_from_scope',
    11225: 'prev_scope',
    11226: 'root_scope',
    11227: 'regnal_number',
    11228: 'set_defacto_liege',
    11229: 'allow_whitepeace',
    11230: 'personal_war',
    11231: 'abandon_ambition_interaction',
    11232: 'stop_backing_ambition_interaction',
    11233: 'join_ambition_interaction',
    11234: 'grant_landed_title_interaction',
    11235: 'appoint_to_office_interaction',
    11236: 'resign_from_office_interaction',
    11237: 'target_type',
    11238: 'creation_trigger',
    11239: 'potential_taker',
    11240: 'potential_creator',
    11241: 'success_trigger',
    11242: 'success_effect',
    11243: 'creation_scope',
    11244: 'creation_effect',
    11245: 'creation_root_scope',
    11246: 'on_attacker_leader_death',
    11247: 'on_defender_leader_death',
    11248: 'on_thirdparty_death',
    11249: 'thirdparty_title',
    11250: 'thirdparty_scope',
    11251: 'thirdparty_title_scope',
    11252: 'end_war',
    11253: 'random_courtier',
    11254: 'random_vassal',
    11255: 'reverse_opinion',
    11256: 'holy_order',
    11257: 'allow_owner_change_if_controlled',
    11258: 'create_mission_command',
    11259: 'mission',
    11260: 'ai_creation_factor',
    11261: 'duchy',
    11262: 'kingdom',
    11263: 'county',
    11264: 'raise_levy',
    11265: 'raise_all_levies',
    11266: 'light_cavalry',
    11267: 'light_infantry',
    11268: 'knights',
    11269: 'pikemen',
    11270: 'galleys',
    11271: 'light_infantry_morale',
    11272: 'light_infantry_offensive',
    11273: 'light_infantry_defensive',
    11274: 'pikemen_morale',
    11275: 'pikemen_offensive',
    11276: 'pikemen_defensive',
    11277: 'light_cavalry_morale',
    11278: 'light_cavalry_offensive',
    11279: 'light_cavalry_defensive',
    11280: 'knights_morale',
    11281: 'knights_offensive',
    11282: 'knights_defensive',
    11283: 'galleys_morale',
    11284: 'galleys_offensive',
    11285: 'galleys_defensive',
    11286: 'has_mission',
    11287: 'authority',
    11288: 'graphical_unit_culture',
    11289: 'combat_event',
    11290: 'skirmish',
    11291: 'melee',
    11292: 'pursue',
    11293: 'is_retreating',
    11294: 'is_flanking',
    11295: 'end_effect',
    11296: 'combat_tactic',
    11297: 'enemy',
    11298: 'create_title_command',
    11299: 'destroy_title_command',
    11300: 'rename_title_command',
    11301: 'any_demesne_title',
    11302: 'any_demesne_province',
    11303: 'any_realm_title',
    11304: 'any_realm_province',
    11305: 'is_playable',
    11306: 'city_vassal_tax_modifier',
    11307: 'castle_vassal_tax_modifier',
    11308: 'temple_vassal_tax_modifier',
    11309: 'estimated_yearly_income',
    11310: 'estimated_yearly_peacetime_income',
    11311: 'city_vassal_min_levy',
    11312: 'castle_vassal_min_levy',
    11313: 'temple_vassal_min_levy',
    11314: 'city_vassal_max_levy',
    11315: 'castle_vassal_max_levy',
    11316: 'temple_vassal_max_levy',
    11317: 'crown_city_vassal_min_levy',
    11318: 'crown_castle_vassal_min_levy',
    11319: 'crown_temple_vassal_min_levy',
    11320: 'agnatic',
    11321: 'true_cognatic',
    11322: 'enatic',
    11323: 'enatic_cognatic',
    11324: 'gender_succ',
    11325: 'succ_law_changer',
    11326: 'change_techfocus_command',
    11327: 'set_crown_city_charters_only',
    11328: 'set_the_kings_peace',
    11329: 'set_investiture',
    11330: 'set_hereditary_job',
    11331: 'head',
    11332: 'hereditary',
    11333: 'short_name',
    11334: 'religion_authority',
    11335: 'add_character_modifier',
    11336: 'remove_character_modifier',
    11337: 'has_character_modifier',
    11339: 'pressed',
    11340: 'feudal_opinion',
    11341: 'city_opinion',
    11342: 'temple_opinion',
    11343: 'rel_head_opinion',
    11344: 'church_opinion',
    11345: 'christian_church_opinion',
    11346: 'dynasty_opinion',
    11347: 'liege_opinion',
    11348: 'vassal_opinion',
    11349: 'infidel_opinion',
    11350: 'opposite_opinion',
    11351: 'spouse_opinion',
    11352: 'same_opinion',
    11353: 'same_opinion_if_same_religion',
    11354: 'same_religion',
    11355: 'muslim_opinion',
    11356: 'zoroastrian_opinion',
    11357: 'jewish_opinion',
    11358: 'christian_opinion',
    11359: 'twin_opinion',
    11360: 'same_religion_opinion',
    11361: 'sex_appeal_opinion',
    11362: 'extra_actor',
    11363: 'extra_recipient',
    11364: 'is_chancellor',
    11365: 'is_marshal',
    11366: 'is_treasurer',
    11367: 'is_spymaster',
    11368: 'is_spiritual',
    11369: 'is_independence',
    11370: 'is_revolt_cb',
    11371: 'same_guardian',
    11372: 'set_name',
    11373: 'reset_name',
    11374: 'reset_adjective',
    11375: 'create_antipope_command',
    11376: 'birth_name',
    11377: 'raise_all_ships',
    11378: 'change_phase_to',
    11379: 'pick_ambition',
    11380: 'pick_plot',
    11381: 'cancel_objective',
    11382: 'independent_rulers',
    11383: 'demesne_size',
    11384: 'priests_can_marry',
    11385: 'priests_can_inherit',
    11386: 'location_ruler_title',
    11387: 'contagiousness',
    11388: 'timeperiod',
    11389: 'outbreak_chance',
    11390: 'disease',
    11391: 'next_outbreak_id',
    11392: 'outbreak_id',
    11393: 'one_only',
    11394: 'dont_break_out_again_entity',
    11395: 'disease_defence',
    11396: 'always_get_message',
    11397: 'levy_reinforce_rate',
    11398: 'spouse_context',
    11399: 'troops',
    11400: 'levy',
    11401: 'flank',
    11402: 'flank_left',
    11403: 'flank_center',
    11404: 'flank_right',
    11405: 'num_of_plot_backers',
    11406: 'plot_decisions',
    11407: 'back_plot',
    11408: 'reverse_back_plot',
    11409: 'leave_plot',
    11410: 'reverse_leave_plot',
    11411: 'reveal_plot',
    11412: 'reveal_plot_w_message',
    11413: 'any_backed_character',
    11414: 'power',
    11415: 'plotter',
    11416: 'plot_power',
    11417: 'plot_power_contribution',
    11418: 'dynasty_realm_power',
    11419: 'plot_months',
    11420: 'same_liege',
    11421: 'is_plot_target_of',
    11422: 'impregnate',
    11423: 'impregnate_cuckoo',
    11424: 'known_father',
    11425: 'was_conceived_a_bastard',
    11426: 'spawned_bastards',
    11427: 'father_of_unborn_known',
    11428: 'is_valid_attraction',
    11429: 'raise_landless_troops',
    11430: 'is_epidemic',
    11431: 'unload_unit',
    11432: 'load_unit',
    11433: 'abort_effect',
    11434: 'raise_all_forces_command',
    11435: 'dismiss_all_forces_command',
    11436: 'build_cost_modifier',
    11437: 'build_time_modifier',
    11438: 'has_nickname',
    11439: 'give_nickname',
    11440: 'reign_start',
    11441: 'ruled_years',
    11442: 'positive',
    11443: 'min_age',
    11444: 'max_age',
    11445: 'only_rulers',
    11446: 'only_independent',
    11447: 'only_playable',
    11448: 'only_men',
    11449: 'only_women',
    11450: 'has_opinion_modifier',
    11451: 'reverse_has_opinion_modifier',
    11452: 'opinion_effect',
    11453: 'relative_power',
    11454: 'is_close_relative',
    11455: 'monthly_salary',
    11456: 'monthly_prestige',
    11457: 'monthly_piety',
    11458: 'has_job_action',
    11459: 'remove_settlement',
    11460: 'random_province_lord',
    11461: 'any_province_lord',
    11462: 'any_province_holding',
    11463: 'random_province_holding',
    11464: 'random_province_character',
    11465: 'any_province_character',
    11466: 'has_guardian',
    11467: 'random_plot_backer',
    11468: 'random_backed_character',
    11469: 'set_guardian',
    11470: 'same_realm',
    11471: 'ask_for_invasion',
    11472: 'ask_for_divorce',
    11473: 'ask_for_excommunication',
    11474: 'become_heretic',
    11475: 'abandon_heresy',
    11476: 'is_heretic',
    11477: 'is_heresy_of',
    11478: 'heresy_icon',
    11479: 'is_parent_religion',
    11480: 'is_reformed_religion',
    11481: 'original_parent',
    11482: 'religion_head',
    11483: 'parent_religion_head',
    11484: 'grammar_transform',
    11485: 'attacker_ai_victory_worth',
    11486: 'attacker_ai_defeat_worth',
    11487: 'defender_ai_victory_worth',
    11488: 'defender_ai_defeat_worth',
    11489: 'game_ai',
    11490: 'seal_overlay',
    11491: 'any_realm_lord',
    11492: 'any_realm_character',
    11493: 'any_vassal',
    11494: 'random_realm_lord',
    11495: 'random_realm_character',
    11496: 'draw_terrain',
    11497: 'draw_water',
    11498: 'draw_borders',
    11499: 'draw_trees',
    11500: 'draw_rivers',
    11501: 'draw_postfx',
    11502: 'draw_sky',
    11503: 'draw_bloom',
    11504: 'call_ally_interaction',
    11505: 'relation_castle',
    11506: 'relation_town',
    11507: 'relation_temple',
    11508: 'show_as_title',
    11509: 'draw_tooltips',
    11510: 'whitepeace',
    11511: 'reverse_demand',
    11512: 'add_piety_modifier',
    11513: 'remove_piety_modifier',
    11514: 'add_prestige_modifier',
    11515: 'remove_prestige_modifier',
    11516: 'tribal_culture',
    11517: 'title_prefix',
    11518: 'random_traits',
    11519: 'draw_hires_terrain',
    11520: 'diploresponse_event',
    11521: 'courtiers',
    11522: 'change_province_name',
    11523: 'draw_citysprawl',
    11524: 'abdicate_to',
    11525: 'abdicate',
    11526: 'child_opinion',
    11527: 'oldest_child_opinion',
    11528: 'youngest_child_opinion',
    11529: 'is_claim_on_liege_cb',
    11530: 'had_province_flag',
    11531: 'had_character_flag',
    11532: 'has_global_flag',
    11533: 'had_global_flag',
    11534: 'set_global_flag',
    11535: 'clr_global_flag',
    11536: 'num_of_extra_landed_titles',
    11537: 'random_demesne_title',
    11538: 'can_be_given_away',
    11539: 'reverse_banish',
    11540: 'imprison',
    11541: 'reverse_imprison',
    11542: 'hidden_tooltip',
    11543: 'if',
    11544: 'capable_only',
    11545: 'only_capable',
    11546: 'remove_opinion',
    11547: 'reverse_remove_opinion',
    11548: 'city_levy_size',
    11549: 'castle_levy_size',
    11550: 'temple_levy_size',
    11551: 'reverse_religion',
    11552: 'reverse_culture',
    11553: 'any_liege',
    11554: 'god_names',
    11555: 'evil_god_names',
    11556: 'scripture_name',
    11557: 'priest_title',
    11558: 'random_dynasty_member',
    11559: 'hide_from',
    11560: 'raise_levies',
    11561: 'dismiss',
    11562: 'force_mult',
    11563: 'original_recipient_only',
    11564: 'has_epidemic',
    11565: 'num_of_prisoners',
    11566: 'imprisoned_days',
    11567: 'camera_speed',
    11568: 'centered_zoom_in',
    11569: 'centered_zoom_out',
    11570: 'truce_days',
    11571: 'divorce_interaction',
    11572: 'camera_tilt',
    11573: 'successor',
    11574: 'character_history',
    11575: 'arrest_chance_modifier',
    11576: 'assassinate_chance_modifier',
    11577: 'action_date',
    11578: 'steal_random_tech',
    11579: 'action_location',
    11580: 'lift_fow',
    11581: 'lift_neighbor_fow',
    11582: 'change_random_civ_tech',
    11583: 'change_random_eco_tech',
    11584: 'change_random_mil_tech',
    11585: 'make_demesne_capital',
    11586: 'using_cb',
    11587: 'any_attacker',
    11588: 'any_defender',
    11589: 'spawn_unit',
    11590: 'spawn_fleet',
    11591: 'playable',
    11592: 'any_host_courtier',
    11593: 'random_host_courtier',
    11594: 'any_pretender_title',
    11595: 'any_heir_title',
    11596: 'is_illness',
    11597: 'is_ill',
    11598: 'cure_illness',
    11599: 'general_opinion',
    11600: 'gain_title_plus_barony_if_unlanded',
    11601: 'usurp_title_plus_barony_if_unlanded',
    11603: 'usurp_title_only',
    11604: 'usurp_title_plus_barony_if_unlanded_and_vassals',
    11605: 'transfer_all_vassals',
    11606: 'hostile_against_others',
    11607: 'press_claim',
    11608: 'last_leader',
    11609: 'tactic',
    11610: 'tactic_day',
    11611: 'overrun',
    11612: 'owner_troops',
    11613: 'owner_ships',
    11614: 'liege_troops',
    11615: 'liege_ships',
    11616: 'known_plots',
    11617: 'rejected',
    11618: 'can_use',
    11619: 'can_use_gui',
    11620: 'can_use_title',
    11621: 'is_betrothed',
    11622: 'add_betrothal',
    11623: 'break_betrothal',
    11624: 'garrison_size',
    11625: 'reverse_war',
    11626: 'change_settlement_name',
    11627: 'transfer_vassals',
    11628: 'is_liege_or_above',
    11629: 'occupy_minors_of_occupied_settlements',
    11630: 'check_all_titles',
    11631: 'check_all_trade_posts',
    11632: 'law_vote',
    11633: 'vote_on_law_command',
    11634: 'approve_law',
    11635: 'upgrades_from',
    11636: 'plot_discovery_chance',
    11637: 'fabricate_claim_mod',
    11638: 'higher_tier_than',
    11639: 'lower_tier_than',
    11640: 'is_abroad',
    11641: 'scaled_by_tax',
    11642: 'scaled_by_biggest_garrison',
    11643: 'show_from_from',
    11644: 'show_root',
    11645: 'hide_new',
    11646: 'hidden',
    11647: 'excommunicated_for',
    11648: 'is_hostile',
    11649: 'is_friendly',
    11650: 'should_exist_trigger',
    11651: 'auto_add_at_year',
    11652: 'last_objective',
    11653: 'dynasty_decisions',
    11654: 'vassal_decisions',
    11655: 'holy_order_decisions',
    11656: 'is_child_of',
    11657: 'military_plot',
    11658: 'intrigue_plot',
    11659: 'murder_plot',
    11660: 'is_located_in',
    11661: 'check_de_jure_tier',
    11662: 'gain_settlements_under_title',
    11663: 'vassalize_or_take_under_title',
    11664: 'subjugate_or_take_under_title',
    11666: 'any_war',
    11667: 'total_claims',
    11668: 'any_title',
    11669: 'any_title_under',
    11670: 'usurp_title',
    11671: 'close_on',
    11672: 'anchor',
    11673: 'hints',
    11674: 'disabled_hints',
    11675: 'any_independent_ruler',
    11676: 'any_current_enemy',
    11677: 'random_independent_ruler',
    11678: 'random_current_enemy',
    11679: 'default',
    11680: 'new_char',
    11681: 'truce',
    11682: 'war_ally',
    11683: 'is_titular',
    11684: 'call_date',
    11685: 'invalid',
    11686: 'set_the_kings_full_peace',
    11687: 'set_protected_inheritance',
    11688: 'set_appoint_generals',
    11689: 'set_appoint_regents',
    11690: 'retain_priority',
    11691: 'de_jure_law_changer',
    11692: 'subunit_changeflank',
    11693: 'client_ping',
    11694: 'siege_defence',
    11695: 'castle_opinion',
    11696: 'town_opinion',
    11697: 'culture_flex',
    11698: 'religion_flex',
    11699: 'light_troops',
    11700: 'heavy_troops',
    11701: 'top_liege',
    11702: 'is_attacker',
    11703: 'short_reign_length',
    11704: 'short_reign_opinion_year_mult',
    11705: 'has_called_crusade',
    11706: 'crusade_target',
    11707: 'crusade_cb',
    11708: 'has_holder',
    11709: 'set_defacto_vassal',
    11710: 'set_allow_title_revokation',
    11711: 'set_allow_free_infidel_revokation',
    11712: 'set_allow_free_revokation',
    11713: 'duchy_revokation',
    11714: 'free_invest_vassal_opinion',
    11715: 'male_dynasty_opinion',
    11716: 'female_dynasty_opinion',
    11717: 'set_flank_leader',
    11718: 'player_left',
    11719: 'player_center',
    11720: 'player_right',
    11721: 'auto_balance',
    11722: 'temple_all_opinion',
    11723: 'can_call_vassals',
    11724: 'has_de_jure_pretension',
    11725: 'grant_kingdom_w_adjudication',
    11726: 'rename_character',
    11727: 'demesne_efficiency',
    11728: 'realm_martial',
    11729: 'realm_diplomacy',
    11730: 'realm_stewardship',
    11731: 'realm_learning',
    11732: 'realm_intrigue',
    11733: 'prevprev',
    11734: 'fromfrom',
    11735: 'can_change_religion',
    11736: 'is_occupied',
    11737: 'excommunicate',
    11738: 'has_truce',
    11739: 'reverse_has_truce',
    11740: 'has_empty_holding',
    11741: 'num_of_settlements',
    11742: 'build_holding',
    11743: 'random_realm_province',
    11744: 'financier',
    11745: 'any_playable_ruler',
    11746: 'random_playable_ruler',
    11747: 'progress',
    11748: 'tech_focus',
    11749: 'is_high_prio',
    11750: 'has_disease',
    11751: 'prison_reason',
    11752: 'revoke_reason',
    11753: 'banish_reason',
    11754: 'execute_reason',
    11755: 'banned_colors',
    11756: 'has_higher_tech_than',
    11757: 'add_law_w_cooldown',
    11758: 'succession_w_cooldown',
    11759: 'is_vassal_or_below',
    11760: 'continue_on_button',
    11761: 'rebel_defection',
    11762: 'ask_to_lift_excommunication',
    11763: 'ask_to_ransom_character',
    11764: 'cannot_cancel_vote',
    11765: 'clear_revolt',
    11766: 'has_raised_levies',
    11767: 'continue_on_unpause',
    11768: 'make_primary_title_command',
    11769: 'father_of_unborn',
    11770: 'real_father',
    11771: 'is_primary_holder_title_tier',
    11772: 'plot_succeeds',
    11773: 'ambition_succeeds',
    11774: 'ambition_opinion',
    11775: 'expectation_of_liege',
    11776: 'ambition_date',
    11777: 'normal_law_changer',
    11778: 'normal_law_change',
    11779: 'any_de_jure_vassal',
    11780: 'any_de_jure_vassal_title',
    11781: 'any_direct_de_jure_vassal_title',
    11782: 'random_direct_de_jure_vassal_title',
    11783: 'is_crusade',
    11784: 'attacker_participation',
    11785: 'defender_participation',
    11786: 'most_participating_attacker',
    11787: 'most_participating_defender',
    11788: 'participation_scaled_piety',
    11789: 'participation_scaled_prestige',
    11790: 'participation_scaled_decadence',
    11791: 'on_add_posttitle',
    11792: 'on_success_posttitle',
    11793: 'on_fail_posttitle',
    11794: 'on_reverse_demand_posttitle',
    11795: 'reflect_titleholder_change',
    11796: 'is_plot_active',
    11797: 'check_actor_direct_vassals',
    11798: 'has_combat',
    11799: 'has_unit',
    11800: 'continue_on_trigger',
    11801: 'continue_on_speed',
    11802: 'second_graphical_culture',
    11803: 'pause',
    11804: 'horde',
    11805: 'closest',
    11806: 'has_horde_culture',
    11807: 'has_crown_law_title',
    11808: 'usurp_date',
    11809: 'is_landed',
    11810: 'empire',
    11811: 'recalc_succession',
    11812: 'has_navy',
    11813: 'cont_on_navy_select_prov',
    11814: 'num_of_emperor_titles',
    11815: 'num_of_duke_titles',
    11816: 'num_of_count_titles',
    11817: 'num_of_baron_titles',
    11818: 'num_of_realm_counties',
    11819: 'can_call_allies',
    11820: 'attacker_score',
    11821: 'defender_score',
    11822: 'de_jure_liege_or_above',
    11823: 'de_jure_vassal_or_below',
    11824: 'raised_days',
    11825: 'opinion_levy_raised_days',
    11826: 'reverse_opinion_levy_raised_days',
    11827: 'set_opinion_levy_raised_days',
    11828: 'reverse_set_opinion_levy_raised_days',
    11829: 'war_score',
    11830: 'outliner_open',
    11831: 'abdicate_to_most_liked_by',
    11832: 'safe_raise',
    11833: 'num_of_titles',
    11834: 'limit_to_button',
    11835: 'transfer_scaled_wealth',
    11836: 'vassal_rank_plot',
    11837: 'vassal_titles',
    11838: 'realm_titles',
    11839: 'independent_titles',
    11840: 'vassal_liege',
    11841: 'can_ask_to_join_war',
    11842: 'disabled_alerts',
    11843: 'can_attack_vassals',
    11844: 'close_priority',
    11845: 'close_pause',
    11846: 'interest_priority',
    11847: 'interest_pause',
    11848: 'special_interest',
    11849: 'holding_type',
    11850: 'attachments',
    11851: 'attach_unit',
    11852: 'detach_unit',
    11853: 'matrilineal',
    11854: 'strength_growth_per_century',
    11855: 'nudge_allowed',
    11856: 'destroy_landed_title',
    11857: 'death_reason',
    11858: 'killer',
    11859: 'pentarchy',
    11860: 'pentarch',
    11861: 'death_natural',
    11862: 'death_trait',
    11863: 'death_murder',
    11864: 'death_murder_unknown',
    11865: 'death_hashshashin',
    11866: 'death_execution',
    11867: 'death_accident',
    11868: 'death_battle',
    11869: 'death_dungeon',
    11870: 'death_suicide',
    11871: 'death_rabble',
    11872: 'death_duel',
    11873: 'death_sacrificed',
    11874: 'death_childbirth',
    11875: 'death_poor_health',
    11876: 'ready_status',
    11877: 'dynasty_named_title',
    11878: 'is_primary_war_defender',
    11879: 'is_primary_war_attacker',
    11880: 'join_defender_wars',
    11881: 'join_attacker_wars',
    11882: 'de_jure_ass_years',
    11883: 'assimilating_liege',
    11884: 'customize_character',
    11885: 'customize_portrait',
    11886: 'sons',
    11887: 'daughters',
    11888: 'married',
    11889: 'customizer',
    11890: 'liege_before_war',
    11891: 'attributes_altered',
    11892: 'command_modifier',
    11893: 'last_change',
    11894: 'vassal_intrigue_plot',
    11895: 'custom_tooltip',
    11896: 'damage',
    11897: 'morale_defence',
    11898: 'morale_offence',
    11899: 'leadership_traits',
    11900: 'dynasty_title_names',
    11901: 'max_wives',
    11902: 'decadence',
    11903: 'make_primary_spouse',
    11904: 'has_regent',
    11905: 'is_contested',
    11906: 'occluded',
    11907: 'new',
    11908: 'match_character',
    11909: 'match_mult',
    11910: 'match_min',
    11911: 'match_max',
    11912: 'any_potential_tribal_county',
    11913: 'random_potential_tribal_county',
    11914: 'tooltip_info',
    11915: 'conquest_culture',
    11916: 'autosaves_to_keep',
    11917: 'in_revolt',
    11918: 'revolt_distance',
    11919: 'allow_distant',
    11920: 'psc_marriage',
    11921: 'cousin_marriage',
    11922: 'pc_marriage',
    11923: 'bs_marriage',
    11924: 'divine_blood',
    11925: 'actual_grant',
    11926: 'depose',
    11927: 'name_tier',
    11928: 'is_conquered',
    11929: 'immortal',
    11930: 'player_shield',
    11931: 'first_type',
    11933: 'membership',
    11934: 'opinion_diff',
    11935: 'reverse_opinion_diff',
    11936: 'as_if_liege',
    11937: 'start_faction',
    11938: 'join_faction',
    11939: 'leave_faction',
    11940: 'second_type',
    11941: 'first_amount',
    11942: 'second_amount',
    11943: 'buy_retinue',
    11944: 'retinue',
    11945: 'set_DLCs',
    11946: 'rate',
    11947: 'disinherit_from_blinding',
    11948: 'set_parent_religion',
    11949: 'supported_claimant',
    11950: 'supported_claimant_title',
    11951: 'change_retinue_reinforce_rate',
    11952: 'terrain_specialization',
    11953: 'set_terrain_specialization',
    11954: 'has_terrain_specialization',
    11955: 'leads_faction',
    11956: 'top_de_jure_capital',
    11957: 'has_top_de_jure_capital',
    11958: 'in_faction',
    11959: 'faction_power',
    11960: 'completely_controls',
    11961: 'religious_enemy',
    11962: 'retinue_reinforce_rate',
    11963: 'purple_born_heirs',
    11964: 'cannot_marry',
    11965: 'blinding',
    11966: 'cannot_inherit',
    11967: 'disband_on_peace',
    11968: 'any_claimant',
    11969: 'add_spouse_matrilineal',
    11970: 'can_have_more_leadership_traits',
    11971: 'raise_liege_levy',
    11972: 'raised_liege_troops',
    11973: 'from_potential',
    11974: 'attacker_alliance_occ_warscore',
    11975: 'succ_law_title',
    11976: 'insert_title_history',
    11977: 'copy_title_history',
    11978: 'copy_title_laws',
    11979: 'war_title',
    11980: 'defending_against_claimant',
    11981: 'has_dlc',
    11982: 'create_retinue',
    11983: 'has_space_for_retinue',
    11984: 'retinue_type',
    11985: 'global_supply_limit',
    11986: 'skin_tone',
    11987: 'province_capital',
    11988: 'num_of_faction_backers',
    11989: 'earmark',
    11990: 'has_earmarked_regiments',
    11991: 'last_dlcs',
    11992: 'last_mods',
    11993: 'counts_as_purple_born',
    11994: 'campaign_fund',
    11995: 'campaign_fund_command',
    11996: 'set_coat_of_arms',
    11997: 'forced_coa_religiongroup',
    11998: 'diplomatic_immunity',
    11999: 'major_revolt',
    12000: 'piety_cost',
    12001: 'prestige_cost',
    12002: 'embargo',
    12003: 'lift_embargo',
    12004: 'has_embargo',
    12005: 'reverse_has_embargo',
    12006: 'low_res_textures',
    12007: 'flank_has_leader',
    12008: 'inherit_chance',
    12009: 'moved_capital',
    12010: 'dynamic',
    12011: 'dyn_title',
    12012: 'holding_dynasty',
    12013: 'create_dynamic_title_command',
    12014: 'family_palace',
    12015: 'is_older_than',
    12016: 'create_trade_post',
    12017: 'force_pow2_textures',
    12018: 'activate_disease',
    12019: 'headgear_that_hides_hair',
    12020: 'tradepost',
    12021: 'trade_post_owner',
    12022: 'custom_name',
    12023: 'has_trade_post',
    12024: 'seize_trade_post',
    12025: 'set_dynasty_flag',
    12026: 'clr_dynasty_flag',
    12027: 'has_dynasty_flag',
    12028: 'had_dynasty_flag',
    12029: 'custom_mapmodes',
    12030: 'no_retinues',
    12031: 'rep_trade_posts',
    12032: 'forbidden_to_lead_armies',
    12033: 'tradevalue',
    12034: 'retinuesize',
    12035: 'scouting',
    12036: 'can_cancel',
    12037: 'defensive_attrition',
    12038: 'my_liegelevy_contribution',
    12039: 'invasion_target',
    12040: 'invasion_date',
    12041: 'prepare_invasion_interaction',
    12042: 'allow_viking_invasion',
    12043: 'preparing_invasion',
    12044: 'destroy_tradepost',
    12045: 'used_for_random',
    12046: 'can_appear',
    12047: 'dukes_called_kings',
    12048: 'baron_titles_hidden',
    12049: 'count_titles_hidden',
    12050: 'preparing_to_invade_me',
    12051: 'loot_province',
    12052: 'loot_holding',
    12053: 'allow_looting',
    12054: 'is_holy_war',
    12055: 'new_title',
    12056: 'create_title',
    12057: 'temporary',
    12058: 'max_consorts',
    12059: 'add_consort',
    12060: 'is_consort',
    12061: 'any_consort',
    12062: 'random_consort',
    12063: 'remove_consort',
    12064: 'consort',
    12065: 'make_consort_interaction',
    12066: 'dismiss_consort_interaction',
    12067: 'rebel_inherited',
    12068: 'tech_levels',
    12069: 'tradevalue_mult',
    12070: 'invest_tech_command',
    12071: 'lootable_gold',
    12072: 'max_lootable_gold',
    12073: 'loot_protected_by_fort',
    12074: 'is_looter',
    12075: 'military_techpoints',
    12076: 'economy_techpoints',
    12077: 'culture_techpoints',
    12078: 'max_tradeposts',
    12079: 'reformed',
    12080: 'reformer_head_of_religion',
    12081: 'original_reformed',
    12082: 'holy_site',
    12083: 'num_of_holy_sites',
    12084: 'realm_size',
    12085: 'realm_manpower',
    12086: 'assimilate',
    12087: 'major_rivers',
    12088: 'allow_rivermovement',
    12089: 'unit_modifier',
    12090: 'unit_home_modifier',
    12091: 'toggle_looter',
    12092: 'light_infantry_perc',
    12093: 'heavy_infantry_perc',
    12094: 'pikemen_perc',
    12095: 'light_cavalry_perc',
    12096: 'knights_perc',
    12097: 'archers_perc',
    12099: 'galleys_perc',
    12100: 'add_number_to_name',
    12101: 'retinuesize_perc',
    12102: 'pagan_coa',
    12103: 'no_event_spawned',
    12104: 'liege_piety',
    12105: 'liege_prestige',
    12106: 'attribute_diff',
    12107: 'used_for_dynasty_names',
    12108: 'christian_portraits',
    12111: 'next_hint',
    12112: 'religious_clothing_priest',
    12113: 'religious_clothing_head',
    12114: 'looter_hostility_days',
    12115: 'peace_months',
    12116: 'tech_level_trigger',
    12117: 'extra_tech_building_start',
    12118: 'county_levy',
    12119: 'replaces',
    12120: 'can_hold_temples',
    12121: 'retract_vassal_interaction',
    12122: 'merge',
    12123: 'banker',
    12124: 'liegelevy_reinforcements',
    12125: 'customize_dynasty',
    12126: 'auto_stop_plots',
    12127: 'father_bastard',
    12128: 'mother_bastard',
    12129: 'favorite_ips',
    12130: 'auto_invite',
    12131: 'pending_backer',
    12132: 'set_real_father',
    12133: 'set_auto_stop_plots',
    12134: 'set_auto_invite_plotters',
    12135: 'can_elect_head',
    12136: 'religious_title',
    12137: 'papal_succession',
    12138: 'elector_funds',
    12139: 'fund',
    12140: 'promote_elector_command',
    12141: 'promoter',
    12142: 'religious_head',
    12143: 'ask_for_money',
    12144: 'notification',
    12145: 'ask_for_crusade',
    12146: 'nominate_bishop_to_pope_interaction',
    12147: 'unit_event',
    12148: 'loot',
    12149: 'than',
    12150: 'likes_better_than',
    12151: 'is_father_real_father',
    12152: 'is_narrow',
    12153: 'bottleneck_chance',
    12154: 'num_subunits',
    12155: 'open_unit_panel',
    12156: 'force_picture',
    12157: 'battle_warscore_mult',
    12158: 'autosave_to_cloud',
    12159: 'ironman',
    12215: 'is_ironman',
    12216: 'ask_for_claim',
    12217: 'hold_election',
    12218: 'best_crusade_claimant',
    12219: 'was_heresy',
    12220: 'prevent_decadence',
    12221: 'grant',
    12222: 'is_recent_grant',
    12223: 'attacker_rel_head_is_ally',
    12224: 'defender_rel_head_is_ally',
    12225: 'rel_head_loyalist',
    12226: 'cancel_on_leader_death',
    12227: 'matrilineal_marriages',
    12228: 'can_have_antipopes',
    12229: 'betrothed',
    12230: 'add_matrilineal_spouse',
    12231: 'is_married_matrilineally',
    12232: 'mp_max_day_lead',
    12233: 'narrow_flank',
    12234: 'savegame_status_update',
    12235: 'download_status',
    12236: 'loading_status',
    12237: 'originator',
    12238: 'fromfromfrom',
    12239: 'ai_patrician',
    12240: 'ai_ruler',
    12241: 'server_console_command',
    12242: 'player_event',
    12243: 'select',
    12244: 'has_regiments',
    12245: 'real_month_of_year',
    12246: 'real_day_of_year',
    12247: 'character_modifier',
    12248: 'feminist',
    12249: 'ocean_region',
    12250: 'is_lowborn',
    12251: 'num_of_dynasty_members',
    12252: 'hide_in_decisions_list',
    12255: 'piety_name',
    12256: 'mercenary_type',
    12257: 'makes_designated_heir',
    12258: 'has_heir_designation',
    12259: 'peace_piety_gain',
    12260: 'reincarnation',
    12261: 'set_reincarnation',
    12262: 'copy_random_personality_trait',
    12263: 'is_reincarnated',
    12264: 'special_troops_perc',
    12265: 'special_troops_morale',
    12266: 'special_troops_offensive',
    12267: 'special_troops_defensive',
    12268: 'caste_tier',
    12269: 'previous_liege',
    12270: 'maintenance',
    12271: 'phase_skirmish_attack',
    12272: 'phase_pursue_attack',
    12273: 'phase_melee_attack',
    12274: 'phase_skirmish_defense',
    12275: 'phase_pursue_defense',
    12276: 'phase_melee_defense',
    12277: 'base_type',
    12278: 'reincarnation_scope',
    12279: 'previous_vassal',
    12280: 'show_as_percent',
    12281: 'is_good',
    12282: 'is_monthly',
    12283: 'is_hidden',
    12284: 'max_decimals',
    12285: 'real_tier',
    12286: 'higher_real_tier_than',
    12287: 'lower_real_tier_than',
    12288: 'compress_autosaves',
    12289: 'is_within_diplo_range',
    12290: 'allow_join',
    12291: 'has_overseas_holdings',
    12292: 'ai_convert_same_group',
    12293: 'ai_convert_other_group',
    12294: 'ai_peaceful',
    12295: 'ai_pacifist',
    12296: 'instant_reply',
    12297: 'execute_on_action',
    12298: 'religious_branch',
    12299: 'designated_heir',
    12300: 'set_designated_heir',
    12301: 'heir',
    12302: 'any_lover',
    12303: 'random_lover',
    12304: 'num_of_lovers',
    12305: 'num_of_spouses',
    12306: 'num_of_consorts',
    12307: 'is_lover',
    12308: 'secondary_event_pictures',
    12309: 'unsafe_move_command',
    12310: 'revoke_honorary_title_interaction',
    12311: 'preparing_adventure_against_me',
    12312: 'warning_level',
    12313: 'last_used_id',
    12314: 'attacker_can_call_allies',
    12315: 'defender_can_call_allies',
    12316: 'is_former_lover',
    12317: 'can_copy_personality_trait_from',
    12318: 'start_war',
    12319: 'ruler_designer_cost',
    12320: 'has_autocephaly',
    12321: 'hostile_within_group',
    12343: 'hsv_center',
    12344: 'hsv_south',
    12345: 'colorbalance_north',
    12346: 'colorbalance_center',
    12347: 'colorbalance_south',
    12348: 'spring',
    12349: 'summer',
    12350: 'autumn',
    12351: 'tree_winter',
    12352: 'tree_winter2',
    12353: 'tree_spring',
    12354: 'tree_spring2',
    12355: 'tree_summer',
    12356: 'tree_summer2',
    12357: 'tree_autumn',
    12358: 'tree_autumn2',
    12359: 'seasons',
    12360: 'hsv_north',
    12361: 'temperate',
    12362: 'dynasty_head',
    12363: 'num_of_max_settlements',
    12364: 'num_of_empty_holdings',
    12365: 'is_looting',
    12366: 'is_looting_in',
    12367: 'borders_major_river',
    12368: 'set_graphical_culture',
    12369: 'is_variable_equal',
    12370: 'allow_in_ruler_designer',
    12371: 'hindu_opinion',
    12372: 'jain_opinion',
    12373: 'buddhism_opinion',
    12374: 'indian_opinion',
    12375: 'orthodox_opinion',
    12376: 'pagan_opinion',
    12377: 'aztec_opinion',
    12378: 'disallow_random_traits',
    12379: 'local_movement_speed',
    12380: 'has_disabled_welcome_screen',
    12381: 'is_allied_with',
    12382: 'any_allied_character',
    12383: 'random_allied_character',
    12384: 'remove_nickname',
    12385: 'tribal_levy_size',
    12386: 'tribal_vassal_max_levy',
    12387: 'tribal_vassal_min_levy',
    12388: 'tribal_vassal_tax_modifier',
    12389: 'tribal_tax_modifier',
    12390: 'learning_scenario',
    12391: 'first_event',
    12392: 'has_wife_event',
    12393: 'revolt_event',
    12394: 'after_revolt_event',
    12395: 'quick_claim',
    12396: 'war_event',
    12397: 'siege_event',
    12398: 'peace_event',
    12399: 'after_peace_event',
    12400: 'decision_event',
    12401: 'first_intrigue_event',
    12402: 'first_backer_opinions',
    12403: 'second_intrigue_event',
    12404: 'second_backer_opinions',
    12405: 'after_intrigue_event',
    12406: 'faction_event',
    12407: 'over_demense_event',
    12408: 'has_child_event',
    12410: 'base_title',
    12411: 'custom_created',
    12412: 'custom_graphics',
    12413: 'is_tribal',
    12423: 'gold_cost',
    12414: 'unknown',
    12415: 'inheritance',
    12416: 'revolt',
    12417: 'created',
    12418: 'election',
    12419: 'revoke',
    12420: 'is_religious',
    12421: 'holy_war',
    12422: 'is_revolt',
    12424: 'chronicle',
    12425: 'chronicle_chapter',
    12426: 'chronicle_entry',
    12427: 'chronicle_collection',
    12428: 'entry',
    12429: 'elective_gavelkind',
    12430: 'portrait',
    12431: 'portrait_culture',
    12432: 'portrait_title_tier',
    12433: 'over_max_demesne_size',
    12434: 'over_vassal_limit',
    12435: 'over_vassal_event',
    12436: 'technology_event',
    12437: 'chronicle_position',
    12438: 'chapter_position',
    12439: 'entry_position',
    12440: 'prev_chronicle_position',
    12441: 'prev_chapter_position',
    12442: 'prev_entry_position',
    12443: 'chronicle_icon_lit',
    12444: 'has_newly_acquired_titles',
    12445: 'newest_acquired_title',
    12446: 'newest_acquired_county_or_barony',
    12447: 'best_fit_character_for_title',
    12448: 'perspective',
    12449: 'num_fitting_characters_for_title',
    12450: 'is_against_tyrany',
    12451: 'vassal_limit',
    12452: 'add_decision',
    12453: 'appointed_regent',
    12454: 'set_coa',
    12455: 'has_coa_graphics',
    12456: 'reset_coa',
    12457: 'in_hiding',
    12458: 'any_plotter',
    12459: 'any_known_plotter',
    12460: 'any_unknown_plotter',
    12461: 'random_plotter',
    12462: 'random_known_plotter',
    12463: 'random_unknown_plotter',
    12464: 'long_character_event',
    12465: 'multiplayer',
    12466: 'is_unique',
    12467: 'winter_supply',
    12468: 'winter_combat',
    12469: 'is_coastal',
    12472: 'tribal_opinion',
    12474: 'triggered_from_code',
    12475: 'has_son_after_daughter_event',
    12476: 'educate_child_event',
    12477: 'dislike_tribal_organization',
    12478: 'highest_ranked_relative',
    12479: 'biggest_realm_size_relative',
    12480: 'landed_kin_prestige_bonus',
    12481: 'tribal_name',
    12482: 'is_mercenary',
    12483: 'can_call_to_war',
    12484: 'vice_royalty',
    12485: 'grant_vice_royalty_interaction',
    12486: 'is_vice_royalty',
    12487: 'set_allow_vice_royalties',
    12488: 'human',
    12489: 'change_tech',
    12490: 'saved_event_target',
    12491: 'save_event_target_as',
    12492: 'titles',
    12493: 'unsafe_religion',
    12494: 'save_global_event_target_as',
    12495: 'clear_global_event_target',
    12496: 'clear_global_event_targets',
    12497: 'peasant_peace_event',
    12498: 'player_name',
    12499: 'unsafe_destroy_landed_title',
    12500: 'maintenance_multiplier',
    12501: 'has_earmarked_regiments_not_raiding',
    12502: 'window_dlc_offset',
    12503: 'dlc',
    12504: 'set_tribal_vassal_levy_control',
    12506: 'de_jure_law_changes',
    12507: 'had_title_flag',
    12508: 'outofsynch',
    12509: 'has_any_building',
    12510: 'is_dying',
    12511: 'is_winter',
    12512: 'create_family_palace',
    12513: 'any_unique_dynasty_vassal',
    12514: 'num_of_unique_dynasty_vassals',
    12515: 'calc_true_if',
    12516: 'is_custom',
    12517: 'is_dynamic',
    12518: 'plot_power_modifier',
    12519: 'localized_nickname',
    12520: 'ai_republic_modifier',
    12521: 'ai_feudal_modifier',
    12522: 'desc_trigger',
    12523: 'title_to_get_rid_of',
    12524: 'set_tribal_vassal_tax_income',
    12525: 'enable_prepared_invasion',
    12526: 'disable_prepared_invasion',
    12527: 'is_crown_law_title',
    12528: 'set_allow_free_duchy_revokation',
    12529: 'vice_royalty_tier',
    12530: 'targetted_decisions',
    12531: 'has_any_opinion_modifier',
    12532: 'age_diff',
    12533: 'break',
    12534: 'show_from_from_from',
    12535: 'repeat_event',
    12536: 'has_focus',
    12537: 'set_focus',
    12538: 'pick_focus',
    12539: 'modifier_name',
    12540: 'usurp',
    12541: 'faction_demand',
    12542: 'has_polygamy',
    12543: 'has_concubinage',
    12544: 'divorce_reason',
    12545: 'same_sex',
    12546: 'male_insult',
    12547: 'male_compliment',
    12548: 'female_insult',
    12549: 'female_compliment',
    12550: 'male_insult_adj',
    12551: 'male_compliment_adj',
    12552: 'female_insult_adj',
    12553: 'female_compliment_adj',
    12554: 'personal_opinion',
    12555: 'reverse_personal_opinion',
    12556: 'personal_opinion_diff',
    12557: 'reverse_personal_opinion_diff',
    12558: 'convert_to_temple',
    12559: 'convert_to_castle',
    12560: 'convert_to_city',
    12561: 'convert_to_tribal',
    12562: 'use_debug_random_level',
    12563: 'fromfromfromfrom',
    12564: 'set_allow_free_vice_royalty_revokation',
    12565: 'vice_royalty_revokation',
    12566: 'ai_target_filter',
    12567: 'sub_realm',
    12568: 'all',
    12569: 'home_court',
    12570: 'court',
    12571: 'combat_rating',
    12572: 'combat_rating_diff',
    12573: 'reverse_combat_rating_diff',
    12574: 'is_modified',
    12575: 'self',
    12576: 'focus',
    12577: 'assim_culture',
    12578: 'any_opinion_modifier_target',
    12579: 'random_opinion_modifier_target',
    12580: 'ignores_defensive_attrition',
    12581: 'set_government_type',
    12582: 'plot_is_known_by',
    12584: 'frame_suffix',
    12585: 'capital_settlement',
    12586: 'allowed_holdings',
    12587: 'allowed_holdings_culture',
    12588: 'allowed_holdings_religion',
    12589: 'allowed_holdings_culture_and_religion',
    12590: 'accepts_liege_governments',
    12591: 'accepts_liege_governments_culture',
    12592: 'accepts_liege_governments_religion',
    12594: 'nor',
    12595: 'clear_event_target',
    12596: 'governments',
    12597: 'vassal_levy_control',
    12598: 'empty_holding_multiplier',
    12599: 'can_imprison_without_reason',
    12600: 'can_revoke_without_reason',
    12601: 'ignores_de_jure_laws',
    12602: 'active_focus',
    12603: 'vassal_tax',
    12604: 'barons_need_dynasty',
    12605: 'can_create_kingdoms',
    12606: 'can_usurp_kingdoms_and_empires',
    12607: 'have_gender_laws',
    12608: 'feudal_governments',
    12609: 'tribal_governments',
    12610: 'republic_governments',
    12611: 'theocracy_governments',
    12612: 'free_revoke_on_governments',
    12613: 'free_revoke_on_governments_culture',
    12614: 'free_revoke_on_governments_religion',
    12615: 'free_revoke_on_governments_culture_and_religion',
    12616: 'max_liege_levy',
    12617: 'max_liege_tax',
    12618: 'ignore_in_vassal_limit_calculation',
    12621: 'can_build_holdings',
    12622: 'merchant_republic',
    12623: 'is_holy_site',
    12624: 'random_realm_title',
    12625: 'focus_date',
    12626: 'allow_viking_invasion_override',
    12627: 'high_god_name',
    12628: 'filter',
    12629: 'crime',
    12630: 'is_foe',
    12631: 'any_close_relative',
    12632: 'landed_title_interaction_command',
    12633: 'destroy_title_interaction',
    12634: 'make_primary_title_interaction',
    12635: 'settlement_interaction_command',
    12636: 'make_capital_settlement_interaction',
    12637: 'title_decisions',
    12638: 'settlement_decisions',
    12639: 'owned',
    12640: 'vassal_owned',
    12641: 'sub_realm_owned',
    12642: 'realm_owned',
    12643: 'dynasty_owned',
    12644: 'convert_to',
    12645: 'unreformed_tribal_opinion',
    12646: 'geographical_region',
    12647: 'counties',
    12648: 'duchies',
    12649: 'reinforce_rate_multiplier',
    12650: 'reinforces',
    12651: 'settle_adventurer_interaction',
    12652: 'is_allowed_to_loot',
    12653: 'exclusive_province',
    12654: 'adventurer',
    12655: 'can_toggle_looting',
    12656: 'set_looting',
    12657: 'set_can_toggle_looting',
    12658: 'realm_manpower_diff',
    12659: 'reverse_realm_manpower_diff',
    12660: 'random_unit',
    12661: 'any_unit',
    12662: 'random_army',
    12663: 'any_army',
    12664: 'random_fleet',
    12665: 'any_fleet',
    12666: 'seafarer',
    12667: 'is_seafarer',
    12668: 'is_island',
    12669: 'main_title',
    12670: 'ruler_female',
    12671: 'add_holding_modifier',
    12672: 'any_mercenary_band',
    12673: 'band_creator',
    12674: 'demesne_garrison_size',
    12675: 'left_flank_leader',
    12676: 'center_flank_leader',
    12677: 'right_flank_leader',
    12678: 'has_raised_standing_troops',
    12679: 'change_title_army_size',
    12680: 'regions',
    12681: 'most_participating_crusader',
    12682: 'is_law_allowed',
    12683: 'is_law_potential',
    12684: 'is_government_allowed',
    12685: 'is_government_potential',
    12686: 'is_decision_allowed',
    12687: 'is_decision_potential',
    12688: 'is_targetted_decision_allowed',
    12689: 'is_targetted_decision_potential',
    12690: 'is_title_decision_allowed',
    12691: 'is_title_decision_potential',
    12692: 'is_settlement_decision_allowed',
    12693: 'is_settlement_decision_potential',
    12694: 'free_revoke_on_tiers',
    12695: 'free_revoke_on_tiers_culture',
    12696: 'free_revoke_on_tiers_religion',
    12697: 'free_revoke_on_tiers_culture_and_religion',
    12698: 'any_defacto_liege',
    12699: 'any_dejure_liege',
    12700: 'defacto_liege_title',
    12701: 'destroy_settlement',
    12702: 'make_capital_holding',
    12703: 'match_settlement',
    12704: 'trigger_switch',
    12705: 'on_trigger',
    12706: 'completely_controls_region',
    12707: 'mercenary_employer',
    12708: 'light_infantry_f',
    12709: 'heavy_infantry_f',
    12710: 'pikemen_f',
    12711: 'light_cavalry_f',
    12712: 'knights_f',
    12713: 'archers_f',
    12714: 'special_troops_f',
    12715: 'galleys_f',
    12716: 'nomadic',
    12717: 'revoke_capital_holding',
    12718: 'is_nomadic',
    12719: 'is_opposite_sex',
    12720: 'refresh_rate',
    12721: 'delete',
    12722: 'trade_route_value',
    12723: 'realm_levy_diff',
    12724: 'reverse_realm_levy_diff',
    12725: 'max_realm_levy_diff',
    12726: 'reverse_max_realm_levy_diff',
    12727: 'realm_levies',
    12728: 'max_realm_levies',
    12729: 'vassal_call_to_arms',
    12730: 'no_vassal_tax',
    12731: 'trade_route',
    12732: 'trade_route_wealth',
    12733: 'random_trade_route_province',
    12734: 'any_trade_route_province',
    12735: 'allowed_to_hold',
    12736: 'allowed_to_grant',
    12737: 'nomad',
    12738: 'convert_to_nomad',
    12739: 'ai_fabricate_claims',
    12740: 'attacking_same_religion_piety_loss',
    12741: 'uses_decadence',
    12742: 'uses_jizya_tax',
    12743: 'uses_piety_for_law_change',
    12744: 'allows_matrilineal_marriage',
    12745: 'free_retract_vassalage',
    12746: 'nomadic_governments',
    12747: 'hire_cost',
    12748: 'tributary',
    12749: 'make_tributary',
    12750: 'remove_tributary',
    12751: 'percentage',
    12752: 'pays_tribute_to',
    12753: 'any_suzerain',
    12754: 'distance_from_realm',
    12755: 'relative_power_with_allies',
    12756: 'trade_route_province',
    12757: 'display_on_map',
    12758: 'strongest_clan_vassal',
    12759: 'weakest_clan_vassal',
    12760: 'is_commander',
    12761: 'appoint_commander_interaction',
    12762: 'resign_commander_interaction',
    12763: 'show_in_council_screen',
    12764: 'honorary_titles_view_item',
    12765: 'bn',
    12766: 'b_d',
    12767: 'd_d',
    12768: 'd_r',
    12769: 'lge',
    12770: 'fat',
    12771: 'mot',
    12772: 'att',
    12773: 'rel',
    12774: 'cul',
    12775: 'g_cul',
    12776: 'nomad_succession',
    12777: 'clan_satisfaction',
    12778: 'max_manpower',
    12779: 'manpower_growth',
    12780: 'max_population',
    12781: 'population_growth',
    12782: 'civilian_population',
    12783: 'max_civilian_population',
    12784: 'civilian_population_growth',
    12785: 'allow_title_revokation',
    12786: 'dont_clear_ferry_status',
    12787: 'reorg_entry',
    12788: 'can_build_castle',
    12789: 'can_build_city',
    12790: 'can_build_temple',
    12791: 'can_build_tribal',
    12792: 'fort',
    12793: 'can_build_forts',
    12794: 'convert_to_fort',
    12795: 'set_subunit_leader',
    12796: 'vc_data',
    12797: 'nand',
    12798: 'trade_post_has_building',
    12799: 'trade_post_has_any_building',
    12800: 'has_game_started',
    12801: 'clan_title',
    12802: 'clear_delayed_event',
    12803: 'is_part_of_plot',
    12804: 'trade_post_item',
    12805: 'is_allowed_holding_type',
    12806: 'is_preferred_holding_type',
    12807: 'preferred_holdings',
    12808: 'forced_contract',
    12809: 'pay_costs',
    12810: 'is_save_game',
    12811: 'create_tradepost',
    12812: 'remove_guardian',
    12813: 'any_landed_title',
    12814: 'random_province',
    12815: 'random_landed_title',
    12816: 'era',
    12817: 'niklas_token_6',
    12818: 'niklas_token_7',
    12819: 'niklas_token_8',
    12820: 'niklas_token_9',
    12821: 'nomad_tax_modifier',
    12822: 'stacking',
    12823: 'primary_settlement',
    12824: 'create_extra_holding',
    12825: 'create_fort',
    12826: 'destroy_fort',
    12827: 'seize_fort',
    12828: 'random_fort',
    12829: 'any_fort',
    12830: 'fort_owner',
    12831: 'num_of_forts',
    12832: 'num_of_trade_posts_diff',
    12833: 'num_of_forts_diff',
    12834: 'has_fort',
    12835: 'fort_has_building',
    12836: 'fort_has_any_building',
    12837: 'global_movement_speed',
    12838: 'clan',
    12839: 'has_castle',
    12840: 'has_temple',
    12841: 'has_city',
    12842: 'has_tribal',
    12843: 'has_settlement_construction',
    12844: 'trade_post_decisions',
    12845: 'fort_decisions',
    12846: 'is_trade_post_decision_allowed',
    12847: 'is_trade_post_decision_potential',
    12848: 'is_fort_decision_allowed',
    12849: 'is_fort_decision_potential',
    12850: 'weakest_clan',
    12851: 'strongest_clan',
    12852: 'weakest_clan_except_me',
    12853: 'strongest_clan_except_me',
    12854: 'weakest_clan_vassal_except_me',
    12855: 'strongest_clan_vassal_except_me',
    12856: 'most_prestigious_clan',
    12857: 'least_prestigious_clan',
    12858: 'most_prestigious_clan_vassal',
    12859: 'least_prestigious_clan_vassal',
    12860: 'most_prestigious_clan_except_me',
    12861: 'least_prestigious_clan_except_me',
    12862: 'most_prestigious_clan_vassal_except_me',
    12863: 'least_prestigious_clan_vassal_except_me',
    12864: 'externals',
    12865: 'random_color',
    12866: 'base_tag',
    12867: 'second_count_vassals',
    12868: 'num_of_subrealm_castles',
    12869: 'num_of_subrealm_temples',
    12870: 'num_of_subrealm_tribes',
    12871: 'num_of_subrealm_empty_provinces',
    12872: 'num_of_demesne_castles',
    12873: 'num_of_demesne_temples',
    12874: 'num_of_demesne_tribes',
    12875: 'num_of_demesne_empty_provinces',
    12876: 'holding_diff',
    12877: 'num_of_subrealm_cities',
    12878: 'num_of_demesne_cities',
    12879: 'first_count_vassals',
    12880: 'target_potential',
    12881: 'nomad_relation',
    12882: 'clan_opinion',
    12883: 'clan_reverse_opinion',
    12884: 'clan_remove_opinion',
    12885: 'clan_reverse_remove_opinion',
    12886: 'absorb_clan_interaction',
    12887: 'set_title_adventurer',
    12888: 'set_title_landless',
    12889: 'create_feud',
    12890: 'feud',
    12891: 'any_feud_rival_clan',
    12892: 'stop_feud',
    12893: 'has_feud_with',
    12894: 'resign_as_commander_interaction',
    12895: 'reverse_clan_opinion',
    12896: 'their_clan_opinion',
    12897: 'clan_opinion_diff',
    12898: 'reverse_clan_opinion_diff',
    12899: 'anti_nomad',
    12900: 'blood_oath',
    12901: 'form_blood_oath_interaction',
    12902: 'has_blood_oath_with',
    12903: 'min',
    12904: 'num_of_feuds',
    12905: 'blood_brother',
    12906: 'settle_feud_interaction',
    12907: 'num_of_king_titles_in_realm',
    12908: 'num_of_duke_titles_in_realm',
    12909: 'num_of_count_titles_in_realm',
    12910: 'num_of_baron_titles_in_realm',
    12911: 'num_of_titles_in_realm',
    12912: 'unsafe_give_minor_title',
    12913: 'split_clan_interaction',
    12914: 'sticky',
    12915: 'caste_opinions',
    12916: 'least_populous_clan_vassal',
    12917: 'most_populous_clan_vassal',
    12918: 'least_populous_clan',
    12919: 'most_populous_clan',
    12920: 'least_populous_clan_vassal_except_me',
    12921: 'most_populous_clan_vassal_except_me',
    12922: 'least_populous_clan_except_me',
    12923: 'most_populous_clan_except_me',
    12924: 'set_tribute_suzerain',
    12925: 'clear_tribute_suzerain',
    12926: 'icon_religion',
    12927: 'max_manpower_mult',
    12928: 'max_population_mult',
    12929: 'retinue_maintenence_cost',
    12930: 'horde_maintenence_cost',
    12931: 'clan_sentiment',
    12932: 'is_active_trigger',
    12933: 'global_winter_supply',
    12934: 'commander_limit',
    12935: 'capital_move_delay',
    12936: 'moved_capital_months',
    12937: 'moved_capital_months_mult',
    12938: 'on_invalidation',
    12939: 'maintaining_mercenaries',
    12940: 'total_manpower',
    12941: 'unused_manpower',
    12942: 'raised_manpower',
    12943: 'historical_nomad',
    12944: 'population_factor',
    12945: 'risks_minor_clan_rising',
    12946: 'ignore_become_unlanded',
    12947: 'recalc_succ',
    12948: 'can_change_to_nomad_on_start',
    12949: 'portrait_government',
    12950: 'uses_prestige_for_law_change',
    12951: 'ignore_caps',
    12952: 'replace_order',
    12953: 'set_title_nomad',
    12954: 'create_oath',
    12955: 'end_oath',
    12956: 'global_trade_route_wealth',
    12957: 'global_trade_route_value',
    12958: 'global_tradevalue',
    12959: 'global_tradevalue_mult',
    12960: 'has_capital',
    12961: 'special_character_title',
    12962: 'set_special_character_title',
    12963: 'remove_special_character_title',
    12964: 'suzerain',
    12965: 'is_tributary',
    12966: 'costs_prestige',
    12967: 'religion_allows_female_temple_holders',
    12968: 'technology_can_spread',
    12969: 'population_and_manpower',
    12970: 'population_and_manpower_growth',
    12971: 'max_population_and_manpower',
    12972: 'character_on_action_command',
    12973: 'on_action_list',
    12974: 'list_box_text',
    12975: 'hint_text_item',
    12976: 'unsafe_war',
    12977: 'reverse_unsafe_war',
    12978: 'borders_lake',
    12979: 'coa_dynasty',
    12980: 'builds_with_prestige',
    12981: 'builds_with_piety',
    12982: 'num_of_government_vassals',
    12983: 'graphical_cultures',
    12984: 'for_population',
    12985: 'scaled_with_population_of',
    12986: 'add_population_scaled',
    12987: 'divine_blood_override',
    12988: 'is_divine_blood',
    12989: 'set_divine_blood',
    12990: 'selectable_character',
    12991: 'title_name',
    12992: 'coalition_command',
    12993: 'invite_to_coalition_command',
    12994: 'leave_coalition',
    12995: 'coalition_target',
    12996: 'coalition_member',
    12997: 'start_from_era_picker',
    12998: 'custom_start',
    12999: 'coalition',
    13000: 'coalition_target_title',
    13001: 'start_coalition_interaction',
    13002: 'leave_coalition_interaction',
    13003: 'coalition_threat',
    13004: 'set_job_action',
    13005: 'add_random_education_trait',
    13006: 'can_grant_title',
    13007: 'has_non_aggression_pact_with',
    13008: 'any_non_aggression_pact_character',
    13009: 'non_agg_pact',
    13010: 'marriage_tie',
    13011: 'set_retreat',
    13012: 'defensive_plot_power_modifier',
    13013: 'form_alliance_interaction',
    13014: 'relative_income_to_liege',
    13015: 'relative_income',
    13016: 'ticking_war_score_multiplier',
    13017: 'among_most_powerful_vassals',
    13018: 'dissolve_alliance_interaction',
    13019: 'started_faction_months',
    13020: 'expired_faction',
    13021: 'valid_months',
    13022: 'is_valid_romance_target',
    13023: 'is_voter',
    13024: 'army_template',
    13025: 'any_voter',
    13026: 'random_voter',
    13027: 'assign_council_title_interaction',
    13028: 'revoke_council_title_interaction',
    13029: 'is_council_content',
    13030: 'set_council_malcontent',
    13031: 'council_discontent_months',
    13032: 'is_heir',
    13033: 'selection',
    13034: 'mult_modifier',
    13035: 'additive_modifier',
    13036: 'for',
    13037: 'against',
    13038: 'additive_opinion_modifier',
    13039: 'random_non_aggression_pact_character',
    13040: 'attacker_dates',
    13041: 'defender_dates',
    13042: 'days_since_last_hostile_action',
    13043: 'assign_voter_title_interaction',
    13044: 'revoke_voter_title_interaction',
    13045: 'default_selection',
    13046: 'relative_power_including_allies_attacker',
    13047: 'relative_power_including_allies_defender',
    13048: 'has_cb',
    13049: 'reverse_has_cb',
    13050: 'disable_non_aggression_pacts',
    13051: 'non_aggression_pact',
    13052: 'temp_alliance',
    13053: 'add_alliance',
    13054: 'additive_power_diff_modifier',
    13055: 'set_council_position',
    13056: 'war_target',
    13057: 'preferred_war_target',
    13058: 'break_alliance',
    13059: 'stored_token_trigger',
    13060: 'cares_about_council',
    13061: 'voting_result',
    13062: 'player_voting_result',
    13063: 'voters_for',
    13064: 'voters_against',
    13065: 'voters_abstained',
    13066: 'pattern_type',
    13067: 'abstain',
    13068: 'voting_patterns',
    13069: 'root_from',
    13070: 'root_fromfrom',
    13071: 'root_fromfromfrom',
    13072: 'root_fromfromfromfrom',
    13073: 'favor',
    13074: 'first_favor_status',
    13075: 'second_favor_status',
    13076: 'first_favor_month_start',
    13077: 'second_favor_month_start',
    13078: 'any_de_jure_liege_title',
    13079: 'threats',
    13080: 'threat_timer',
    13081: 'buy_favor_interaction',
    13082: 'call_in_favor_interaction',
    13083: 'add_favor',
    13084: 'reverse_add_favor',
    13085: 'remove_favor',
    13086: 'reverse_remove_favor',
    13087: 'council_discontent_reason',
    13088: 'council_discontent_start',
    13089: 'council_discontent_update',
    13090: 'owes_favor_to',
    13091: 'holds_favor_on',
    13092: 'held_favor_activated_on',
    13093: 'owed_favor_activated_by',
    13094: 'any_favor_ower',
    13095: 'random_favor_ower',
    13096: 'any_favor_holder',
    13097: 'random_favor_holder',
    13098: 'siphons_income_to_creator',
    13099: 'request_support_interaction',
    13100: 'replace_captain_on_death',
    13101: 'adjust_siphon_factor',
    13102: 'set_siphon_factor_to',
    13103: 'child_insult',
    13104: 'child_compliment',
    13105: 'child_insult_adj',
    13106: 'child_compliment_adj',
    13107: 'origin_description',
    13108: 'set_mercenary_maintenance_modifier',
    13109: 'has_mercenary_maintenance_modifier',
    13110: 'has_mercenary_band',
    13111: 'council_position',
    13112: 'council_position_start_month',
    13113: 'cut_mercenary_creator_relation',
    13114: 'mercenary_siphon_factor',
    13115: 'replace_mercenary_captain_interaction',
    13116: 'disable_council_voting_on_issue',
    13117: 'enable_council_voting_on_issue',
    13118: 'change_mercenary_composition',
    13119: 'troop_type',
    13120: 'from_type',
    13121: 'change',
    13122: 'educator',
    13123: 'rejected_law_changes',
    13124: 'law_vote_date',
    13125: 'is_distance_limited',
    13126: 'childhood',
    13127: 'can_swap_job_title',
    13128: 'both_parent_has_trait_inherit_chance',
    13129: 'allowed_to_target_tributaries',
    13130: 'allowed_to_target_suzerains',
    13131: 'set_councilor_faction_join_restriction',
    13132: 'has_councilor_faction_join_restriction',
    13133: 'enforce_peace',
    13134: 'enforcer',
    13135: 'enforce_peace_start',
    13136: 'clear_focus',
    13137: 'law_type',
    13138: 'council',
    13139: 'obligations',
    13140: 'left_value',
    13141: 'right_value',
    13142: 'slider_sprite',
    13143: 'law_groups',
    13144: 'government_flavor',
    13145: 'decay',
    13146: 'decay_speed',
    13147: 'decay_count',
    13148: 'favor_used',
    13149: 'stop_enforce_peace_interaction',
    13150: 'enforce_peace_blocked',
    13151: 'liege_law',
    13152: 'ai_vassal_will_do',
    13153: 'may_request_law_change',
    13154: 'allowed_for_councillors',
    13155: 'ask_to_declare_war_interaction',
    13156: 'message_to_declare_war_interaction',
    13157: 'council_voting',
    13158: 'additive_realm_size_modifier',
    13159: 'set_allow_feminism',
    13160: 'set_allow_gender_laws',
    13161: 'balance',
    13162: 'additive_compared_realm_size_modifier',
    13163: 'steal_population_scaled',
    13164: 'is_zeus_save',
    13165: 'can_hold_titles',
    13166: 'decline_law',
    13167: 'infamy',
    13168: 'total_infamy',
    13169: 'potential_traits',
    13170: 'in_coalition_against',
    13171: 'has_position',
    13172: 'law_change_timeout',
    13173: 'owns_mercenary_units',
    13174: 'has_council',
    13175: 'crown_law_change_timeout',
    13176: 'set_allows_matrilineal_marriage',
    13177: 'is_landed_title_being_created',
    13178: 'form_non_aggression_pact_interaction',
    13179: 'non_aggression_pact_timeout',
    13180: 'force_join_faction_interaction',
    13181: 'has_liege_enforced_peace',
    13182: 'will_liege_enforce_peace',
    13183: 'is_tyranny_cb',
    13184: 'ask_realm_peace_interaction',
    13185: 'ask_for_council_position_interaction',
    13186: 'is_job_ambition',
    13187: 'free_levies_in_offensive_war',
    13188: 'realm_peace_enforced',
    13189: 'realm_peace_warmup',
    13190: 'retire_effect',
    13191: 'localisation',
    13192: 'change_infamy',
    13193: 'infamy_modifier',
    13194: 'save_succession',
    13195: 'restore_succession',
    13196: 'council_succession_vote',
    13197: 'revoke_trigger',
    13198: 'context_music',
    13199: 'most_popular_vassal',
    13200: 'fired',
    13201: 'betrothal_from_favor',
    13202: 'is_powerful_vassal',
    13203: 'is_multiplayer_host_character',
    13204: 'real_father_even_if_dead',
    13205: 'any_child_even_if_dead',
    13206: 'random_child_even_if_dead',
    13207: 'any_dynasty_member_even_if_dead',
    13208: 'random_dynasty_member_even_if_dead',
    13209: 'any_sibling_even_if_dead',
    13210: 'random_sibling_even_if_dead',
    13211: 'random_spouse_even_if_dead',
    13212: 'is_symptom',
    13213: 'symptom',
    13214: 'has_any_symptom',
    13215: 'supported_checksum',
    13216: 'is_targeted_decision_allowed',
    13217: 'is_targeted_decision_potential',
    13218: 'targeted_decisions',
    13219: 'scaled_prestige',
    13220: 'scaled_piety',
    13221: 'set_pentarch_title',
    13222: 'has_instances_of_character_modifier',
    13223: 'remove_character_modifiers',
    13224: 'max',
    13225: 'update_frequency',
    13226: 'outbreak_scenario',
    13227: 'start_provinces',
    13228: 'excluded_regions',
    13229: 'spread_direction',
    13230: 'selected_scenario',
    13231: 'start_outbreak',
    13232: 'spawn_disease',
    13233: 'num_of_symptoms',
    13234: 'yearly_province_pulse',
    13235: 'infection_date',
    13236: 'update_date',
    13237: 'disease_period',
    13238: 'origins_province',
    13239: 'disease_outbreak',
    13240: 'regional_percentage',
    13241: 'province_infection_duration',
    13242: 'on_character_infection',
    13243: 'is_sick',
    13244: 'min_nb_province',
    13245: 'max_nb_province',
    13246: 'character_infection_chances',
    13247: 'on_province_infection',
    13248: 'total_years_played',
    13249: 'max_total_provinces',
    13250: 'can_outbreak',
    13251: 'custom_reason',
    13252: 'long_desc',
    13253: 'short_desc',
    13254: 'violent',
    13255: 'sound_effect',
    13256: 'c_d',
    13257: 'can_nokiller',
    13258: 'execution',
    13259: 'martial_penalty',
    13260: 'intrigue_penalty',
    13261: 'diplomacy_penalty',
    13262: 'stewardship_penalty',
    13263: 'learning_penalty',
    13264: 'fertility_penalty',
    13265: 'health_penalty',
    13266: 'is_penalty',
    13267: 'execution_method',
    13268: 'extra_effect',
    13269: 'hospital',
    13270: 'hospital_decisions',
    13271: 'hospital_level',
    13272: 'hospital_tax_modifier',
    13273: 'hospital_levy_size',
    13274: 'can_build_hospitals',
    13275: 'is_wicked',
    13277: 'is_neutral',
    13278: 'death_default',
    13279: 'vice',
    13281: 'death_text_default',
    13282: 'is_virtous',
    13283: 'virtue',
    13284: 'death_sound',
    13285: 'sound_list',
    13286: 'disease_gfx',
    13287: 'remove_province_modifiers',
    13288: 'remove_holding_modifiers',
    13289: 'has_instances_of_province_modifier',
    13290: 'has_instances_of_holding_modifier',
    13291: 'has_holding_modifier',
    13293: 'ignore_requirements',
    13295: 'faction_leader',
    13296: 'faction_exists',
    13297: 'can_join_existing',
    13298: 'export_to_variable',
    13299: 'while',
    13300: 'retinue_points_max',
    13301: 'retinue_points_used',
    13302: 'retinue_points_free',
    13303: 'total_tax_value',
    13304: 'holding_tax_value',
    13305: 'after',
    13306: 'hidden_effect',
    13307: 'hidden_trigger',
    13308: 'same_wonder_as',
    13309: 'achievements',
    13310: 'game_rules',
    13311: 'game_speed',
    13312: 'has_game_rule',
    13313: 'set_game_rules',
    13314: 'murder_unknown',
    13315: 'add_holding_slot',
    13316: 'spread_through_water',
    13317: 'past_provinces',
    13318: 'rip',
    13319: 'any_hospital',
    13320: 'num_of_hospitals',
    13321: 'num_of_hospitals_diff',
    13322: 'has_hospital',
    13323: 'hospital_has_any_building',
    13324: 'is_hospital_decision_allowed',
    13325: 'is_hospital_decision_potential',
    13326: 'hospital_owner',
    13327: 'succession_gfx',
    13328: 'leader_traits',
    13329: 'in_seclusion',
    13330: 'vassal_wars',
    13331: 'set_truce',
    13332: 'hospital_has_building',
    13333: 'long_reign_penalty_years',
    13334: 'heir_text_default',
    13335: 'province_embellishment',
    13336: 'any_courtier_or_vassal',
    13337: 'random_courtier_or_vassal',
    13338: 'any_player',
    13339: 'random_player',
    13340: 'pacification_timeout',
    13341: 'set_pacified',
    13342: 'false',
    13343: 'true',
    13344: 'has_assigned_minor_title',
    13345: 'has_children',
    13346: 'has_living_children',
    13347: 'create_hospital',
    13348: 'destroy_hospital',
    13349: 'random_hospital',
    13350: 'add_to_extra_holding',
    13351: 'destroy_in_extra_holding',
    13352: 'forced_portrait',
    13353: 'accepted_eula_version',
    13354: 'song_name',
    13355: 'war_participation',
    13356: 'is_landed_title_allowed',
    13357: 'force_host',
    13358: 'de_facto_liege_title',
    13359: 'is_incapable',
    13360: 'is_pilgrim',
    13361: 'same_regnal_name',
    13362: 'has_inheritance_blocker',
    13363: 'dynastic_prestige',
    13364: 'set_preferred_capital',
    13365: 'hist',
    13366: 'gov',
    13367: 'emp',
    13368: 'prp',
    13369: 'dnt',
    13370: 'dh',
    13371: 'fer',
    13372: 'prs',
    13373: 'emi',
    13374: 'eme',
    13375: 'eyi',
    13376: 'eypi',
    13377: 'avi',
    13378: 'lgr',
    13379: 'dmn',
    13380: 'cpos',
    13381: 'cpos_start',
    13382: 'acdate',
    13383: 'acloc',
    13384: 'spectit',
    13385: 'nick',
    13386: 'fem',
    13387: 'oh',
    13388: 'ascul',
    13389: 'diplo_imm',
    13390: 'drt',
    13391: 'curinc',
    13392: 'curexp',
    13393: 'vars',
    13394: 'md',
    13395: 'rej',
    13396: 'dynnam',
    13397: 'rfat',
    13398: 'retrat',
    13399: 'btrh',
    13400: 'bstd',
    13401: 'lacks_dlc',
    13402: 'observer',
    13403: 'has_flag',
    13404: 'de_jure_law_change',
    13405: 'hidden_from_others',
    13406: 'same_trait_visibility',
    13407: 'stlmt_ttl',
    13408: 'members',
    13410: 'immortal_age',
    13411: 'landed_inheritance',
    13412: 'random_close_relative',
    13413: 'localisation_key',
    13414: 'hard_to_convert',
    13415: 'is_hard_to_convert',
    13416: 'eu4trait',
    13417: 'weight',
    13418: 'society_rank',
    13419: 'is_secret',
    13420: 'criminal',
    13421: 'plots',
    13422: 'ambitions',
    13423: 'monthly_currency_gain',
    13424: 'per_attribute',
    13425: 'has_trait',
    13426: 'primary_attribute',
    13427: 'is_in_society',
    13430: 'society_currency',
    13431: 'society_influence',
    13432: 'any_society_member',
    13433: 'random_society_member',
    13434: 'all_society_members',
    13435: 'join_society',
    13436: 'leave_society',
    13437: 'society_rank_up',
    13438: 'society_rank_down',
    13439: 'society',
    13440: 'in_society',
    13441: 'is_artifact',
    13442: 'kill_character',
    13443: 'victim',
    13444: 'add_history',
    13445: 'post_message',
    13446: 'has_artifact',
    13447: 'num_of_artifacts',
    13448: 'any_artifact',
    13449: 'transfer_artifact',
    13450: 'random_artifact',
    13451: 'quality',
    13452: 'add_artifact',
    13453: 'destroy_artifact',
    13454: 'has_artifact_flag',
    13455: 'is_artifact_active',
    13456: 'obtained',
    13457: 'artifacts',
    13458: 'startup_populate',
    13459: 'startup_limit',
    13460: 'can_join_society',
    13461: 'set_quest',
    13462: 'devil_worshipper',
    13463: 'any_quester_targeting_this',
    13464: 'clr_quest',
    13465: 'set_quest_target',
    13466: 'clr_quest_target',
    13467: 'quests',
    13468: 'char_target',
    13469: 'prov_target',
    13470: 'title_target',
    13471: 'quest',
    13472: 'random_quester_targeting_this',
    13473: 'any_quester',
    13474: 'random_quester',
    13475: 'any_quest_target_of_this',
    13476: 'random_quest_target_of_this',
    13477: 'any_quest_target',
    13478: 'random_quest_target',
    13479: 'is_quest_target',
    13480: 'is_quest_target_of',
    13481: 'has_quest',
    13482: 'has_any_quest',
    13483: 'num_of_quests',
    13484: 'is_targetted_by_quest',
    13485: 'is_targetted_by_any_quest',
    13486: 'num_of_quests_targeting_this',
    13487: 'is_visible',
    13488: 'join_society_command',
    13489: 'leave_society_command',
    13490: 'static_backer',
    13491: 'grandmaster',
    13492: 'member_score_per_rank',
    13493: 'member_score_per_attribute',
    13494: 'member_score_per_currency',
    13495: 'member_score',
    13496: 'member',
    13497: 'show_society',
    13498: 'society_member_of',
    13499: 'change_society_currency',
    13500: 'society_can_rank_up',
    13501: 'society_can_rank_down',
    13502: 'interested_in_society',
    13503: 'show_interest_in_society_command',
    13504: 'set_interested_society',
    13505: 'change_plot_power',
    13506: 'base_plot_power',
    13507: 'same_society_as',
    13508: 'influence',
    13509: 'attach_to_unit_order',
    13510: 'add_ally_order_command',
    13511: 'remove_ally_order_command',
    13512: 'validation_trigger',
    13513: 'take_province_order',
    13514: 'hunter_killer_order',
    13515: 'days_in_society',
    13516: 'days_at_current_society_rank',
    13517: 'failure',
    13518: 'is_society_grandmaster',
    13519: 'set_society_grandmaster',
    13520: 'society_ranks_gfx',
    13521: 'remove_society_quest_command',
    13522: 'disc_soc',
    13523: 'orders',
    13524: 'set_discovered_society',
    13525: 'discovered_society',
    13526: 'clr_discovered_society',
    13527: 'is_society_discovered',
    13528: 'is_society_discovered_real',
    13529: 'opinion_to_other_members',
    13530: 'opinion_to_pretenders',
    13531: 'opinion_to_perceived_members',
    13532: 'quest_target',
    13533: 'offmap',
    13535: 'liege_modifier',
    13536: 'attribute_cap',
    13537: 'threat_decay_speed',
    13538: 'good_traits',
    13539: 'bad_traits',
    13540: 'ask_to_join_ambition_interaction',
    13541: 'society_quest_event',
    13542: 'build_cost_city_modifier',
    13543: 'build_cost_castle_modifier',
    13544: 'build_cost_temple_modifier',
    13545: 'build_cost_tribal_modifier',
    13546: 'build_time_city_modifier',
    13547: 'build_time_castle_modifier',
    13548: 'build_time_temple_modifier',
    13549: 'build_time_tribal_modifier',
    13550: 'local_build_cost_city_modifier',
    13551: 'local_build_cost_castle_modifier',
    13552: 'local_build_cost_temple_modifier',
    13553: 'local_build_cost_tribal_modifier',
    13554: 'local_build_time_city_modifier',
    13555: 'local_build_time_castle_modifier',
    13556: 'local_build_time_temple_modifier',
    13557: 'local_build_time_tribal_modifier',
    13558: 'add_society_modifier',
    13559: 'static_modifier_cap',
    13560: 'decision_priority',
    13561: 'set_army_base_command',
    13562: 'reset_unit_command',
    13563: 'reset_ai',
    13564: 'siege_focus_order',
    13565: 'consideration',
    13568: 'can_destroy',
    13569: 'indestructible',
    13570: 'is_indestructible',
    13571: 'spawn_chance',
    13572: 'save_slot',
    13573: 'character_player_data',
    13574: 'auto_assign_commanders',
    13575: 'copy_name',
    13576: 'any_controlled_unit',
    13577: 'random_controlled_unit',
    13578: 'unit_is_in_combat',
    13579: 'is_navy',
    13580: 'is_society_rank_full',
    13581: 'society_show_interest_cooldown',
    13582: 'join_society_cooldown',
    13583: 'damage_unit',
    13584: 'damage_unit_morale',
    13585: 'flank_has_tactic',
    13586: 'set_flank_tactic',
    13587: 'society_type',
    13588: 'realm_character_percent',
    13589: 'cooldown',
    13590: 'society_is_devil_worshiper',
    13591: 'society_is_criminal',
    13592: 'hide_layers',
    13593: 'has_portrait_property',
    13594: 'society_rank_up_decision',
    13595: 'society_leader',
    13596: 'obedient',
    13597: 'non_interference',
    13598: 'generated_societies',
    13599: 'generated_artifacts',
    13600: 'portrait_is_female',
    13601: 'adult',
    13602: 'midage',
    13603: 'oldage',
    13604: 'portrait_age',
    13605: 'portrait_religion',
    13606: 'portrait_gfx_culture',
    13607: 'easter_egg',
    13608: 'ee',
    13609: 'has_quest_target',
    13610: 'clear_education_trait',
    13611: 'portrait_clothing',
    13612: 'portrait_society',
    13613: 'allow_property_values',
    13614: 'portrait_society_rank',
    13615: 'show_portrait',
    13616: 'society_plot',
    13617: 'org_owner',
    13618: 'set_artifact_flag',
    13619: 'clr_artifact_flag',
    13620: 'artifact_owner',
    13621: 'artifact_original_owner',
    13622: 'artifact_type',
    13623: 'artifact',
    13624: 'is_artifact_same_type_as',
    13625: 'artifact_type_owned_by',
    13626: 'society_decisions',
    13627: 'opinion_per_rank_above',
    13628: 'obedience_tooltip',
    13629: 'non_interference_tooltip',
    13630: 'murder_plot_power_modifier',
    13631: 'portrait_has_trait',
    13632: 'global_levy_size',
    13633: 'global_garrison_size',
    13634: 'offer_consort_interaction',
    13635: 'ignore_king_peace',
    13636: 'spawn_date',
    13637: 'scaled_by_influence',
    13638: 'tooltip_info_modifier',
    13639: 'new_artifact',
    13640: 'set_original_owner',
    13641: 'original_artifact_owner',
    13642: 'mass_embark',
    13643: 'portrait_culture_group',
    13644: 'set_auto_assign_commander_command',
    13645: 'day_of_birth',
    13646: 'month_of_birth',
    13647: 'year_of_birth',
    13648: 'set_creation_date',
    13649: 'portrait_tier',
    13650: 'slot',
    13651: 'slots',
    13652: 'toggle_equip_artifact_command',
    13653: 'equipped',
    13654: 'is_building',
    13655: 'trade_post_is_building',
    13656: 'fort_is_building',
    13657: 'hospital_is_building',
    13658: 'genetic_father',
    13659: 'genetic_mother',
    13660: 'give_artifact_interaction',
    13661: 'allowed_gift',
    13662: 'has_secret_religion',
    13663: 'set_secret_religion',
    13665: 'convert_to_secret_religion',
    13666: 'original_owner',
    13667: 'public',
    13668: 'true_religion',
    13669: 'secret_religion',
    13670: 'true_religion_group',
    13671: 'secret_religion_group',
    13672: 'clear_secret_religion',
    13673: 'secret',
    13674: 'secret_religion_visibility_trigger',
    13675: 'can_see_secret_religion',
    13676: 'dynamic_cult',
    13677: 'associated_religion',
    13678: 'secret_religious_cult',
    13679: 'secret_cult',
    13680: 'dynamic_cult_template',
    13681: 'religion_scope',
    13682: 'secret_religion_scope',
    13683: 'true_religion_scope',
    13684: 'culture_scope',
    13685: 'religions',
    13686: 'societies',
    13687: 'clear_flags_with_prefix',
    13688: 'fallback_text',
    13689: 'is_interested_in_any_society',
    13690: 'castes',
    13691: 'currency_name',
    13692: 'holder_title',
    13693: 'governor_title',
    13694: 'holder_succession',
    13695: 'offmap_powers',
    13696: 'offmap_power',
    13697: 'policies',
    13698: 'statuses',
    13699: 'is_offmap_holder',
    13700: 'killer_icon',
    13701: 'default_religion',
    13702: 'default_culture',
    13703: 'prev_status',
    13704: 'cur_status',
    13705: 'prev_policy',
    13706: 'cur_policy',
    13707: 'diplomatic_range',
    13708: 'temple_names',
    13709: 'has_policy',
    13710: 'has_status',
    13711: 'has_policy_flag',
    13712: 'prev_policy_flag',
    13713: 'has_status_flag',
    13714: 'prev_status_flag',
    13715: 'set_status',
    13716: 'set_policy',
    13717: 'has_offmap_flag',
    13718: 'has_offmap_tmp_flag',
    13719: 'set_offmap_tmp_flag',
    13720: 'clr_offmap_tmp_flag',
    13721: 'set_offmap_holder',
    13722: 'set_offmap_name',
    13723: 'has_offmap_name',
    13724: 'has_had_offmap_name',
    13725: 'names',
    13726: 'prev_holder',
    13727: 'temple_list',
    13728: 'temple_name',
    13729: 'temple_indices',
    13730: 'only',
    13731: 'policy',
    13732: 'is_offmap_ruler',
    13733: 'is_offmap_governor',
    13734: 'text_editor',
    13735: 'text_editor_postfix',
    13736: 'offmap_currencies',
    13737: 'add_offmap_currency',
    13738: 'has_offmap_currency',
    13739: 'dynasty_name_first',
    13740: 'currency_gain',
    13741: 'offmap_decisions',
    13742: 'give_decision',
    13743: 'tribute_decisions_trigger',
    13744: 'boon_decisions_trigger',
    13745: 'is_offmap_tag',
    13746: 'death_effect',
    13747: 'third_party',
    13748: 'third_party_potential',
    13749: 'third_party_allow',
    13750: 'third_party_filter',
    13751: 'ai_third_party_filter',
    13752: 'offmap_ruler',
    13753: 'show_third_party_score',
    13754: 'third_party_score',
    13755: 'court_including_me',
    13756: 'home_court_including_me',
    13757: 'dynasty_including_me',
    13758: 'all_including_me',
    13759: 'society_including_me',
    13760: 'realm_including_me',
    13761: 'sub_realm_including_me',
    13762: 'breaks_at_suzerain_death',
    13763: 'breaks_at_tributary_death',
    13764: 'suzerain_must_defend',
    13765: 'tributary_can_be_summoned',
    13766: 'cbs_against_suzerain',
    13767: 'income_tribute_percentage',
    13768: 'reinforce_tribute_percentage',
    13769: 'piety_to_suzerain',
    13770: 'prestige_to_suzerain',
    13771: 'piety_to_tributary',
    13772: 'prestige_to_tributary',
    13773: 'threat_to_suzerain',
    13774: 'tributary_type',
    13775: 'tributary_must_defend',
    13776: 'tributaries_can_infight',
    13777: 'suzerain_can_join_infighting',
    13778: 'tributaries_can_unite',
    13779: 'max_defender_occupation_score',
    13780: 'max_attacker_occupation_score',
    13781: 'breaks_on_realm_change',
    13782: 'become_secret_heretic',
    13783: 'has_offmap_news_enabled',
    13784: 'offmap_news',
    13785: 'set_offmap_news_command',
    13786: 'tributary_name',
    13787: 'suzerain_name',
    13788: 'set_trade_route_base_value',
    13789: 'set_trade_route_value_multiplier',
    13790: 'currency_below_zero',
    13791: 'trade_post_display_trigger',
    13792: 'non_aggression_modifier',
    13793: 'death_offmap',
    13794: 'show_scope_change',
    13795: 'hostages_block_cb',
    13796: 'tributary_plural',
    13797: 'tribute_name',
    13798: 'interested_in_society_of_character',
    13799: 'likes',
    13800: 'dislikes',
    13801: 'context',
    13802: 'liked_by_offmap',
    13803: 'disliked_by_offmap',
    13804: 'set_offmap_like',
    13805: 'set_offmap_dislike',
    13806: 'as_if_allied_to',
    13807: 'att_ticking_war_score_multiplier',
    13808: 'def_ticking_war_score_multiplier',
    13809: 'conditional_tooltip',
    13810: 'gets_religion_opinion_penalties',
    13811: 'gives_religion_opinion_penalties',
    13812: 'vassal_government_opinion_penalties',
    13813: 'can_be_claimed',
    13814: 'can_be_usurped',
    13815: 'offmap_succession',
    13816: 'threatening',
    13817: 'army_reinforce_rate',
    13818: 'days_of_supply',
    13819: 'any_neighbor_independent_ruler',
    13820: 'random_neighbor_independent_ruler',
    13821: 'demesne_size_compared_to_limit',
    13822: 'multiplicative_trade_post_income_modifier',
    13823: 'can_create_empires',
    13824: 'extra_ai_eval_troops',
    13825: 'relative_realm_size',
    13826: 'window_name',
    13827: 'had_offmap_flag',
    13828: 'set_offmap_flag',
    13829: 'clr_offmap_flag',
    13830: 'generate_tooltip',
    13831: 'suzerain_can_be_called',
    13832: 'offmap_prev_ruler',
    13833: 'realm_levies_plus_allies',
    13834: 'currency_reset_on_dynasty_change',
    13835: 'button_name',
    13836: 'display_trigger',
    13837: 'supplied',
    13838: 'coa_religion',
    13839: 'portrait_offmap',
    13840: 'ai_check_interval',
    13841: 'shares_realm_border_with',
    13842: 'num_of_society_members',
    13843: 'hire_range',
    13844: 'icon_triggers',
    13845: 'can_demand_religious_conversion',
    13846: 'actually_culture',
    13847: 'unsafe_destroy_artifact',
    13848: 'else_if',
    13849: 'else',
    13850: 'artifact_can_be_gifted_to',
    13851: 'is_offmap_tag_including_dead',
    13852: 'army_rally_points',
    13853: 'navy_rally_points',
    13854: 'rally_point_command',
    13855: 'add',
    13856: 'unsafe_impregnate',
    13857: 'unsafe_impregnate_cuckoo',
    13858: 'fail_trigger_effect',
    13859: 'closest_to_capital',
    13860: 'is_artifact_equipped',
    13861: 'clear_variable',
    13862: 'beginning_of_history',
    13863: 'log_scopes',
    13864: 'is_parent_of',
    13865: 'is_cousin_of',
    13866: 'is_aunt_uncle_of',
    13867: 'is_nibling_of',
    13868: 'is_grandparent_of',
    13869: 'is_grandchild_of',
    13870: 'is_descendant_of',
    13871: 'is_ancestor_of',
    13872: 'had_artifact_flag',
    13873: 'trade_route_control',
    13874: 'indirectly_owned',
    13875: 'trade_posts',
    13876: 'trade_post_locations',
    13877: 'is_vassal_or_below_of',
    13878: 'is_liege_or_above_of',
    13879: 'independent_rulers_including_me',
    13880: 'close_relatives',
    13881: 'offmap_has_like',
    13882: 'offmap_has_dislike',
    13883: 'any_pupil',
    13884: 'random_pupil',
    13885: 'buttons',
    13886: 'can_use_cb',
    13887: 'validation_effect',
    13888: 'is_or_was_offmap_power_ruler',
    13889: 'attacker_unoccupied_warscore',
    13890: 'defender_unoccupied_warscore',
    13891: 'only_check_triggers',
    13892: 'plot_date',
    13893: 'set_offmap_currency',
    13894: 'show_third_party_potential',
    13895: 'any_tributary',
    13896: 'random_tributary',
    13897: 'player_heir',
    13898: 'had_offmap_tmp_flag',
    13899: 'days_since_status_change',
    13900: 'days_since_policy_change',
    13901: 'policy_change',
    13902: 'status_change',
    13903: 'set_description',
    13904: 'can_inherit',
    13905: 'custom_event',
    13906: 'max_attacker_battle_score',
    13907: 'max_defender_battle_score',
    13908: 'capturing_attacker_is_complete_victory',
    13909: 'capturing_defender_is_complete_victory',
    13910: 'marriage_ai_command',
    13913: 'artifact_age',
    13914: 'has_known_creation_date',
    13915: 'set_looter_hostility_days',
    13916: 'effect_even_if_dead',
    13917: 'could_be_parent_of',
    13918: 'could_be_child_of',
    13919: 'join_crusade_if_bordering_hostile',
    13920: 'transparent_wastelands',
    13921: 'wasteland_adjacency_coloring',
    13922: 'is_connected_to',
    13923: 'any_connected_province',
    13924: 'random_connected_province',
    13925: 'any_disconnected_province',
    13926: 'random_disconnected_province',
    13927: 'realm_capital',
    13928: 'sea_gap',
    13929: 'land_gap',
    13930: 'can_naval_path_to',
    13931: 'naval_distance',
    13932: 'save_persistent_event_target',
    13933: 'clear_persistent_event_target',
    13934: 'alternate_start',
    13935: 'generate_dukes',
    13936: 'kill_list',
    13937: 'shattered',
    13938: 'first_alternate_start',
    13939: 'checked',
    13940: 'unchecked',
    13941: 'patrilineal',
    13942: 'all_descendants',
    13943: 'create_bloodline',
    13944: 'allow_bastards',
    13945: 'add_to_bloodline',
    13946: 'add_bloodline_member',
    13947: 'remove_from_bloodline',
    13948: 'remove_bloodline_member',
    13949: 'destroy_bloodline',
    13950: 'set_bloodline_flag',
    13951: 'clr_bloodline_flag',
    13952: 'has_bloodline_flag',
    13953: 'bloodline',
    13954: 'is_bloodline_member_of',
    13955: 'is_bloodline_founder_of',
    13956: 'any_bloodline',
    13957: 'random_bloodline',
    13958: 'any_bloodline_member',
    13959: 'random_bloodline_member',
    13960: 'is_alternate_start',
    13961: 'is_shattered_world',
    13962: 'has_alternate_start_setting',
    13963: 'has_alternate_start_parameter',
    13964: 'setting',
    13965: 'parameters',
    13966: 'no_inheritance',
    13969: 'female_ruler_percentage',
    13968: 'apply_before_generation',
    13970: 'double_slider',
    13971: 'min_default',
    13972: 'max_default',
    13973: 'int_parameters',
    13974: 'double_int_parameters',
    13975: 'age_span',
    13976: 'alternate_start_value',
    13977: 'alternate_start_min_value',
    13978: 'alternate_start_max_value',
    13979: 'feudal',
    13980: 'tribal_nomadic',
    13981: 'nomadic_in_alt_start',
    13982: 'one',
    13983: 'two',
    13984: 'three',
    13985: 'four',
    13986: 'five',
    13987: 'six',
    13988: 'seven',
    13989: 'holding_slots',
    13990: 'consolidate_dukes',
    13991: 'any_kill_list_character',
    13992: 'random_kill_list_character',
    13993: 'num_of_kill_list_characters',
    13994: 'shares_any_bloodline_with',
    13995: 'any_bloodline_member_including_dead',
    13996: 'random_bloodline_member_including_dead',
    13997: 'any_owned_bloodline',
    13998: 'random_owned_bloodline',
    13999: 'founder',
    14000: 'ai_acceptance',
    14001: 'powers',
    14002: 'show_only_failed_conditions',
    14003: 'marriage_ai',
    14004: 'gfx_culture_scope',
    14005: 'had_bloodline_flag',
    14006: 'yes_threshold',
    14007: 'show_maybe_for_human',
    14008: 'immune_to_prune',
    14009: 'delay',
    14010: 'practical_age',
    14011: 'diplomacy_icon',
    14012: 'add_special_interest',
    14013: 'remove_special_interest',
    14014: 'special_interests',
    14015: 'culture_spread',
    14016: 'religion_spread',
    14017: 'num_culture_provinces',
    14018: 'num_religion_provinces',
    14019: 'culture_group_spread',
    14020: 'religion_group_spread',
    14021: 'full_random',
    14022: 'alternate_start_full',
    14023: 'alternate_start_min_year',
    14024: 'alternate_start_max_year',
    14025: 'flat',
    14026: 'marriage_percentage',
    14027: 'dejure_kingdoms',
    14028: 'dejure_empires',
    14029: 'dejure_kingdom_size',
    14030: 'dejure_empire_size',
    14031: 'dejure_kingdom_spread',
    14032: 'dejure_empire_spread',
    14033: 'set_immune_to_pruning',
    14034: 'is_immune_to_pruning',
    14035: 'true_father',
    14036: 'true_father_even_if_dead',
    14037: 'twin',
    14038: 'twin_even_if_dead',
    14039: 'is_twin_of',
    14040: 'show_progress_bar',
    14041: 'progress_bar_value',
    14042: 'stop_society_progress',
    14043: 'start_society_progress',
    14044: 'add_society_progress',
    14045: 'set_society_progress',
    14046: 'society_has_active_progress',
    14047: 'society_progress',
    14048: 'holy_sites',
    14049: 'holy_site_spread',
    14050: 'num_holy_sites_generated',
    14051: 'holy_site_distance',
    14052: 'religion_distance',
    14053: 'culture_names',
    14054: 'religion_names',
    14055: 'religion_name_formats',
    14056: 'has_pressed_claim',
    14057: 'has_strong_pressed_claim',
    14058: 'has_weak_pressed_claim',
    14059: 'is_name_randomized',
    14060: 'set_peace_piety_gain',
    14061: 'set_pacifist',
    14062: 'set_convert_other_groups',
    14063: 'set_convert_same_group',
    14064: 'set_peace_prestige_loss',
    14065: 'set_ai_aggression',
    14066: 'set_unit_modifier',
    14067: 'set_unit_home_modifier',
    14068: 'set_hard_to_convert',
    14069: 'set_raised_vassal_opinion_loss',
    14071: 'set_max_wives',
    14072: 'set_max_consorts',
    14073: 'set_feminist',
    14074: 'set_heir_designation',
    14075: 'set_short_reign_opinion_year_mult',
    14076: 'set_jizya_tax',
    14077: 'set_can_retire_to_monastery',
    14078: 'set_can_excommunicate',
    14079: 'set_can_grant_divorce',
    14080: 'set_can_grant_invasion_cb',
    14081: 'set_can_grant_claim',
    14082: 'set_can_call_crusade',
    14083: 'set_pc_marriage',
    14084: 'set_bs_marriage',
    14085: 'set_psc_marriage',
    14086: 'set_cousin_marriage',
    14087: 'set_seafaring',
    14088: 'set_allow_looting',
    14089: 'set_allow_rivermovement',
    14090: 'set_flag',
    14091: 'clr_flag',
    14092: 'had_flag',
    14093: 'features',
    14094: 'tooltip_info_custom',
    14095: 'has_pentarchy',
    14096: 'has_religion_feature',
    14097: 'has_selected_religion_feature',
    14098: 'make_reformer_head_of_religion',
    14099: 'set_no_head_of_religion',
    14100: 'no_head_of_religion',
    14101: 'set_autocephaly',
    14102: 'set_pentarchy',
    14103: 'trigger_if',
    14104: 'trigger_else',
    14105: 'trigger_else_if',
    14106: 'costs_piety',
    14107: 'modulo_variable',
    14108: 'fallback',
    14109: 'male_opinion',
    14110: 'female_opinion',
    14111: 'cancel_pregnancy',
    14112: 'uses_bride_price',
    14113: 'sort_priority',
    14114: 'religion_features',
    14115: 'set_religion_head',
    14116: 'set_uses_decadence',
    14117: 'set_can_have_antipopes',
    14118: 'first_succession_favor_month_start',
    14119: 'second_succession_favor_month_start',
    14120: 'call_in_favor_succession_vote_interaction',
    14121: 'set_priests_can_marry',
    14122: 'set_female_temple_holders',
    14123: 'set_priests_can_inherit',
    14124: 'set_ignores_defensive_attrition',
    14125: 'set_character_modifier',
    14126: 'add_intermarry',
    14127: 'remove_intermarry',
    14128: 'clear_intermarry',
    14129: 'set_defensive_attrition',
    14130: 'actual_light_infantry',
    14131: 'actual_heavy_infantry',
    14132: 'use_first_valid',
    14133: 'score_value',
    14134: 'game_pause',
    14135: 'clear_prison_reasons',
    14136: 'clear_banish_reasons',
    14137: 'clear_revoke_reasons',
    14138: 'clear_execute_reasons',
    14139: 'is_prefix',
    14140: 'show_value',
    14141: 'death_date_desc',
    14142: 'full_name',
    14143: 'is_random_world',
    14144: 'num_counties',
    14145: 'duke_threshold',
    14146: 'duke_ignore_rate',
    14147: 'duke_vassalization_rate',
    14148: 'generate_random_dukes',
    14149: 'king_threshold',
    14150: 'king_ignore_rate',
    14151: 'king_vassalization_rate',
    14152: 'generate_random_kings',
    14153: 'emperor_threshold',
    14154: 'emperor_ignore_rate',
    14155: 'emperor_vassalization_rate',
    14156: 'generate_random_emperors',
    14157: 'shattered_default',
    14158: 'random_default',
    14159: 'set_short_name',
    14160: 'preferred_limit',
    14161: 'triggered_gain',
    14162: 'generate_random_holdings',
    14163: 'feudal_seeds',
    14164: 'tribal_seeds',
    14165: 'nomadic_seeds',
    14166: 'holding_spread',
    14167: 'interface_skin',
    14168: 'merge_republic_interface',
    14169: 'society_has_members',
    14170: 'society_is_active',
    14171: 'is_society',
    14172: 'women_can_take_consorts',
    14173: 'consort_of',
    14174: 'is_senior_consort_party',
    14175: 'set_women_can_take_consorts',
    14176: 'men_can_take_consorts',
    14177: 'set_men_can_take_consorts',
    14178: 'playthrough_id',
    14179: 'separator',
    14180: 'custom',
    14181: 'any_artifact_owner',
    14182: 'random_artifact_owner',
    14183: 'previous_artifact_owner',
    14184: 'show_trait',
    14185: 'alt_start_achievements',
    14186: 'alt_start_default',
    14187: 'alt_start_game_rules',
    14188: 'set_religious_branch',
    14189: 'new_bloodline',
    14190: 'set_picture',
    14191: 'parent_religion',
    14192: 'full_hostility',
    14193: 'matrilineal_override',
    14194: 'has_religion_features',
    14195: 'seg',
    14196: 'pgoals',
    14197: 'telws',
    14198: 'telbc',
    14199: 'telde',
    14200: 'telld',
    14201: 'telsc',
    14202: 'male_temple_holders',
    14203: 'set_male_temple_holders',
    14204: 'religion_allows_male_temple_holders',
    14205: 'usurpation_abides_allow',
    14206: 'religion_group_spawn',
    14207: 'any_religion_distance',
    14208: 'max_emblems',
    14209: 'emblem_chance',
    14210: 'has_randomized_features',
    14211: 'third_party_portrait',
    14212: 'heresy_desc',
    14213: 'use_new_crusade',
    14214: 'change_crusade_target',
    14215: 'is_preparing_crusade',
    14216: 'crusade_preparation_strength',
    14217: 'set_crusade_target',
    14218: 'pledge_crusade_participation',
    14219: 'has_pledged_crusade_participation',
    14220: 'set_crusade_beneficiary',
    14221: 'crusade_beneficiary',
    14222: 'crusade_preparation_time_elapsed',
    14223: 'crusade_preparation_time_remaining',
    14224: 'lock_crusade_target',
    14225: 'crusade_target_char',
    14226: 'crusade_target_title',
    14227: 'any_unit_leader',
    14228: 'random_unit_leader',
    14229: 'is_in_same_unit_as',
    14230: 'is_sub_unit_leader',
    14231: 'set_official_crusade_recipient',
    14232: 'any_crusade_participant',
    14233: 'random_crusade_participant',
    14234: 'set_crusade_pot_multiplier',
    14235: 'official_crusade_recipient',
    14236: 'cancel_crusade',
    14237: 'has_crusade_war_started',
    14238: 'crusade',
    14239: 'participants',
    14240: 'last_changer',
    14241: 'pot',
    14242: 'scripted_effect_command',
    14243: 'distribute_crusade_pot',
    14244: 'add_to_crusade_gold_pot',
    14245: 'add_to_crusade_prestige_pot',
    14246: 'add_to_crusade_piety_pot',
    14247: 'add_to_crusade_artifact_pot',
    14248: 'crusade_gold_pot',
    14249: 'crusade_prestige_pot',
    14250: 'crusade_piety_pot',
    14251: 'crusade_artifact_pot',
    14252: 'gold',
    14253: 'set_crusader_king',
    14254: 'add_dynasty_modifier',
    14255: 'remove_dynasty_modifier',
    14256: 'has_dynasty_modifier',
    14257: 'holding_garrison_percent',
    14258: 'holding_raisable_levy_percent',
    14259: 'holding_total_levy_percent',
    14260: 'holding_garrison',
    14261: 'holding_raisable_levy',
    14262: 'holding_total_levy',
    14263: 'distribute_crusade_target_title',
    14264: 'uses_new_crusade',
    14265: 'any_crusade_defender',
    14266: 'random_crusade_defender',
    14267: 'pledge_crusade_defense',
    14268: 'has_pledged_crusade_defense',
    14269: 'is_crusade_target',
    14270: 'crusader_king',
    14271: 'crusade_defense_strength',
    14272: 'crusade_religion_targeting_us',
    14273: 'is_religion_crusade_target',
    14274: 'set_player_character',
    14275: 'shown_privacy_version',
    14276: 'additive_exported_value_modifier',
    14277: 'num_vassals_with_minor_title',
    14278: 'rel_head_defense',
    14279: 'set_rel_head_defense',
    14280: 'on_invalidation_title',
    14281: 'on_invalidation_posttitle',
    14282: 'prompt_name',
    14283: 'rename_artifact_command',
    14284: 'rename_bloodline_command',
    14285: 'show_in_settings',
    14286: 'name_list',
    14287: 'is_bloodline_active',
    14288: 'copy_artifact_history',
    14289: 'elective_voting_rules',
    14290: 'can_land_path_to',
    14291: 'reason',
    14292: 'tooltip_desc',
    14293: 'tooltip_reason',
    14294: 'candidate_vote_score',
    14295: 'elector_selection',
    14296: 'elector_vote_strength',
    14297: 'elector_stances',
    14298: 'candidate_trigger',
    14299: 'max_amount_of_electors',
    14300: 'shown_legal_documents',
    14301: 'player_age',
    14302: 'player_portrait',
    14303: 'duel',
    14304: 'et',
    14305: 'votes',
    14306: 'has_elector_stance',
    14307: 'stances',
    14308: 'pt',
    14309: 'st',
    14310: 'any_eldership_title',
    14311: 'random_eldership_title',
    14312: 'any_elector_character',
    14313: 'random_elector_character',
    14314: 'any_pretender',
    14315: 'random_pretender',
    14316: 'voting_rules',
    14317: 'steam_rich_presence',
    14318: 'gold_cost_payed',
    14319: 'prestige_cost_payed',
    14320: 'piety_cost_payed',
    14321: 'needs_new_target',
    14322: 'crusade_set_target_or_cancel_command',
    14323: 'add_god_name',
    14324: 'set_high_god_name',
    14325: 'remove_god_names',
    14326: 'add_evil_god_name',
    14327: 'remove_evil_god_names',
    14328: 'succession_electors',
    14329: 'diplo_view_region',
    14330: 'pi',
    14331: 'tr',
    14332: 'd',
    14333: 'ry',
    14334: 'li',
    14335: 'hi',
    14336: 'lc',
    14337: 'hc',
    14338: 'ar',
    14339: 'ga',
    14340: 'marriage_ignore_religion',
    14341: 'special_event',
    14342: 'portrait_is_patrician',
    14343: 'portrait_in_command',
    14344: 'add_age',
    14345: 'set_gender',
    14346: 'opposite',
    14347: 'set_holy_site',
    14348: 'remove_holy_site',
    14349: 'set_holy_site_with_heresies',
    14350: 'remove_holy_site_with_heresies',
    14351: 'bloodline_is_active_for',
    14352: 'main_menu_tab_open',
    14353: 'last_event_shown',
    14354: 'unit_graphical_culture',
    14355: 'unit_graphical_cultures',
    14356: 'update',
    14357: 'levels',
    14358: 'feat_progress',
    14359: 'event_upcoming_version',
    14360: 'event_active_version',
    14361: 'first_event_upcoming',
    14362: 'first_event_active',
    14363: 'bronzeman',
    14364: 'playthrough_duration',
    14365: 'background_picture',
    14366: 'hide_frame',
    14367: 'dlc_sale_seen',
    14368: 'announcement_seen',
    14369: 'announcement_reshow',
    14370: 'subscription_highlights',
    14371: 'ola_token_13',
    14372: 'ola_token_14',
    14373: 'ola_token_15',
    14374: 'ola_token_16',
    14375: 'ola_token_17',
    14376: 'ola_token_18',
    14377: 'ola_token_19',
    14378: 'ola_token_20',
    14379: 'ola_token_21',
    14380: 'ola_token_22',
    14381: 'ola_token_23',
    14382: 'ola_token_24',
    14383: 'ola_token_25',
    14384: 'ola_token_26',
    14385: 'ola_token_27',
    14386: 'ola_token_28',
    14387: 'ola_token_29',
    14388: 'ola_token_30',
    14389: 'ola_token_31',
    14390: 'ola_token_32',
    14391: 'ola_token_33',
    14392: 'ola_token_34',
    14393: 'ola_token_35',
    14394: 'ola_token_36',
    14395: 'ola_token_37',
    14396: 'ola_token_38',
    14397: 'ola_token_39',
    14398: 'ola_token_40',
    14399: 'ola_token_41',
    14400: 'ola_token_42',
    14401: 'ola_token_43',
    14402: 'ola_token_44',
    14403: 'ola_token_45',
    14404: 'ola_token_46',
    14405: 'ola_token_47',
    14406: 'ola_token_48',
    14407: 'ola_token_49',
    14408: 'ola_token_50',
    14409: 'stage',
    14410: 'available_upgrades',
    14411: 'wonder',
    14412: 'any_wonder',
    14413: 'any_owned_wonder',
    14414: 'any_realm_wonder',
    14415: 'original_wonder_owner',
    14416: 'any_wonder_owner',
    14417: 'any_previous_wonder_owner',
    14418: 'previous_wonder_owner',
    14419: 'wonder_owner',
    14420: 'any_wonder_upgrade',
    14421: 'any_owned_wonder_upgrade',
    14422: 'any_realm_wonder_upgrade',
    14423: 'is_building_wonder',
    14424: 'is_building_wonder_upgrade',
    14425: 'num_of_wonders',
    14426: 'has_wonder',
    14427: 'num_of_wonder_upgrades',
    14428: 'johan_token_27',
    14429: 'has_wonder_upgrade',
    14430: 'has_wonder_flag',
    14431: 'has_wonder_upgrade_flag',
    14432: 'wonder_age',
    14433: 'wonder_upgrade_age',
    14434: 'wonder_stage_age',
    14435: 'wonder_stage',
    14436: 'random_wonder',
    14437: 'random_owned_wonder',
    14438: 'random_realm_wonder',
    14439: 'random_wonder_owner',
    14440: 'random_previous_wonder_owner',
    14441: 'random_wonder_upgrade',
    14442: 'random_owned_wonder_upgrade',
    14443: 'random_realm_wonder_upgrade',
    14444: 'destroy_wonder_upgrade',
    14445: 'add_wonder_upgrade',
    14446: 'add_wonder_stage',
    14447: 'set_wonder_flag',
    14448: 'clr_wonder_flag',
    14449: 'set_wonder_upgrade_flag',
    14450: 'clr_wonder_upgrade_flag',
    14451: 'abort_wonder_construction',
    14452: 'any_upgrade_on_wonder',
    14453: 'random_upgrade_on_wonder',
    14454: 'is_active',
    14455: 'wonder_historical_event_other_character',
    14458: 'add_wonder_upgrade_slots',
    14459: 'wonder_build_cost_modifier',
    14460: 'wonder_build_time_modifier',
    14461: 'propagate_bloodline_from',
    14462: 'local_modifier',
    14463: 'owner_modifier',
    14464: 'realm_modifier',
    14465: 'saving_for_wonder',
    14466: 'has_full_court',
    14467: 'num_of_courtiers',
    14468: 'free_court_slots',
    14469: 'court_size_modifier',
    14470: 'court_size_maintenance_cost_modifier',
    14471: 'add_wonder',
    14472: 'is_important_character_to',
    14473: 'inclusive',
    14474: 'form_new_kingdom',
    14475: 'form_new_empire',
    14476: 'dismissed_rtt',
    14477: 'dismissed_splash',
    14478: 'user_id',
    14479: 'dismissed_rtt2',
    14480: 'joel_token_22',
    14481: 'joel_token_23',
    14482: 'joel_token_24',
    14483: 'joel_token_25',
    14484: 'joel_token_26',
    14485: 'joel_token_27',
    14486: 'joel_token_28',
    14487: 'joel_token_29',
    14488: 'joel_token_30',
    14489: 'joel_token_31',
    14490: 'joel_token_32',
    14491: 'joel_token_33',
    14492: 'joel_token_34',
    14493: 'joel_token_35',
    14494: 'joel_token_36',
    14495: 'joel_token_37',
    14496: 'joel_token_38',
    14497: 'joel_token_39',
    14498: 'joel_token_40',
    14499: 'joel_token_41',
    14500: 'joel_token_42',
    14501: 'joel_token_43',
    14502: 'joel_token_44',
    14503: 'joel_token_45',
    14504: 'custom_modifier_text',
    14505: 'any_demesne_wonder_upgrade',
    14506: 'random_demesne_wonder_upgrade',
    14507: 'any_demesne_wonder',
    14508: 'random_demesne_wonder',
    14509: 'construct_wonder_stage_command',
    14510: 'upgrade_slots',
    14511: 'gold_cost_flat',
    14512: 'gold_cost_ticking',
    14513: 'wonder_construction_type',
    14514: 'completed',
    14515: 'is_constructing',
    14516: 'wonder_upgrade',
    14517: 'wonder_historical_event_date',
    14519: 'wonder_historical_event_character',
    14521: 'construction_history',
    14522: 'pause_wonder_construction',
    14523: 'construction_paused',
    14524: 'has_started_building_wonder',
    14525: 'has_started_building_wonder_upgrade',
    14526: 'wonder_type',
    14527: 'allow_cancel',
    14528: 'is_in_water',
    14529: 'default_picture_stage',
    14530: 'rename_wonder_command',
    14531: 'new_name',
    14532: 'old_name',
    14533: 'allow_coastal',
    14534: 'is_being_looted',
    14535: 'is_damaged',
    14536: 'looting_progress',
    14537: 'loot_time',
    14538: 'restore_time',
    14539: 'restore_progress',
    14540: 'is_being_restored',
    14541: 'set_wonder_damaged',
    14542: 'restoration_paused',
    14543: 'wonder_loot_command',
    14544: 'wonder_retore_command',
    14545: 'restore',
    14546: 'custom_desc',
    14547: 'allow_construction',
    14548: 'has_custom_name',
    14549: 'has_custom_description',
    14550: 'restore_cost_flat',
    14551: 'restore_cost_ticking',
    14552: 'is_at_lootable_stage',
    14553: 'is_at_max_stage',
    14555: 'background_frame_number',
    14556: 'show_model',
    14557: 'background_overrides',
    14558: 'show_in_history',
    14559: 'set_dynasty_name',
    14560: 'law_set_allow_matrilineal_marriage',
    14561: 'remove_wonder_upgrade_slots',
    14562: 'build_wonder',
    14563: 'destroy_wonder',
    14564: 'build_wonder_upgrade',
    14566: 'set_wonder_stage',
    14567: 'set_wonder_stage_construction_percent',
    14568: 'set_wonder_name',
    14569: 'set_wonder_description',
    14570: 'model',
    14571: 'johan_token_11',
    14572: 'johan_token_12',
    14573: 'johan_token_13',
    14574: 'johan_token_14',
    14575: 'johan_token_15',
    14576: 'johan_token_16',
    14577: 'johan_token_17',
    14578: 'johan_token_18',
    14579: 'johan_token_19',
    14580: 'johan_token_20',
    14581: 'johan_token_21',
    14582: 'johan_token_22',
    14583: 'johan_token_23',
    14584: 'johan_token_24',
    14585: 'johan_token_25',
    14586: 'johan_token_26',
    14588: 'johan_token_28',
    14589: 'johan_token_29',
    14590: 'johan_token_30',
    14591: 'johan_token_31',
    14592: 'johan_token_32',
    14593: 'johan_token_33',
    14594: 'johan_token_34',
    14595: 'johan_token_35',
    14596: 'johan_token_36',
    14597: 'johan_token_37',
    14598: 'johan_token_38',
    14599: 'johan_token_39',
    14600: 'johan_token_40',
    14601: 'johan_token_41',
    14602: 'johan_token_42',
    14603: 'johan_token_43',
    14604: 'johan_token_44',
    14605: 'johan_token_45',
    14606: 'johan_token_46',
    14607: 'johan_token_47',
    14608: 'johan_token_48',
    14609: 'add_custom_history',
    14610: 'custom_history',
    14611: 'is_local_human_observer',
    14612: 'set_wonder_model',
    14613: 'update_model',
    14614: 'daniel_token_6',
    14615: 'daniel_token_7',
    14616: 'daniel_token_8',
    14617: 'daniel_token_9',
    14618: 'daniel_token_10',
    14619: 'daniel_token_11',
    14620: 'daniel_token_12',
    14621: 'daniel_token_13',
    14622: 'daniel_token_14',
    14623: 'daniel_token_15',
    14624: 'daniel_token_16',
    14625: 'daniel_token_17',
    14626: 'daniel_token_18',
    14627: 'daniel_token_19',
    14628: 'daniel_token_20',
    14629: 'daniel_token_21',
    14630: 'daniel_token_22',
    14631: 'daniel_token_23',
    14632: 'daniel_token_24',
    14633: 'daniel_token_25',
    14634: 'daniel_token_26',
    14635: 'daniel_token_27',
    14636: 'daniel_token_28',
    14637: 'daniel_token_29',
    14638: 'daniel_token_30',
    14639: 'daniel_token_31',
    14640: 'daniel_token_32',
    14641: 'daniel_token_33',
    14642: 'daniel_token_34',
    14643: 'daniel_token_35',
    14644: 'daniel_token_36',
    14645: 'daniel_token_37',
    14646: 'daniel_token_38',
    14647: 'daniel_token_39',
    14648: 'daniel_token_40',
    14649: 'daniel_token_41',
    14650: 'daniel_token_42',
    14651: 'daniel_token_43',
    14652: 'daniel_token_44',
    14653: 'daniel_token_45',
    14654: 'daniel_token_46',
    14655: 'daniel_token_47',
    14656: 'daniel_token_48',
    14657: 'daniel_token_49',
    14658: 'daniel_token_50',
    12160: 'tutorial',
    12161: 'window',
    12162: 'tutorial_window',
    12163: 'tutorial_window_position',
    12164: 'tutorial_window_size',
    12165: 'page',
    12166: 'window_position',
    12167: 'window_size',
    12168: 'exclusive',
    12169: 'close_window',
    12170: 'text1',
    12171: 'text2',
    12172: 'text3',
    12173: 'text4',
    12174: 'text5',
    12175: 'text6',
    12176: 'text7',
    12177: 'text8',
    12178: 'text9',
    12179: 'text10',
    12180: 'select_province',
    12181: 'select_army',
    12182: 'select_navy',
    12183: 'goto',
    12184: 'mapmode',
    12185: 'zoom',
    12186: 'panel',
    12187: 'domestic_panel',
    12188: 'province_panel',
    12189: 'message_log',
    12190: 'select_units',
    12191: 'save_game',
    12192: 'interactive',
    12193: 'args',
    12194: 'cont_on_unit_select',
    12195: 'allow_unpause',
    12196: 'allow_screens',
    12197: 'continue_on_interface',
    12198: 'lockzoom',
    12199: 'lockpan',
    12200: 'specific_exclusive',
    12201: 'continue_on_action',
    12202: 'custom_action',
    12203: 'unit_set',
    12204: 'basic_start',
    12205: 'intermediary_start',
    12206: 'advanced_start',
    12207: 'allow_screen',
    12208: 'allow_merge',
    12209: 'cont_on_unit_select_prov',
    12210: 'cont_on_unit_id_select',
    12211: 'allow_province_click',
    12212: 'custom_int_arg',
    12213: 'organisation',
    12214: 'cont_on_prov_select',
};
exports.default = dict;
